var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpRightImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 853.281,
    height: 531.451,
    viewBox: "0 0 853.281 531.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enter_OTP-pana",
    "data-name": "Enter OTP-pana",
    transform: "translate(-34.09 -46.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-35",
    transform: "translate(34.09 48.198)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1553",
    "data-name": "Rectangle 1553",
    width: 86.307,
    height: 89.97,
    transform: "translate(33.293 2.71)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1554",
    "data-name": "Rectangle 1554",
    width: 86.307,
    height: 89.97,
    transform: "translate(27.448 2.71)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10784",
    "data-name": "Path 10784",
    d: "M142.3,140.07H56V50h86.357Zm-86.307,0h86.244V50.1H56Z",
    transform: "translate(-28.517 -47.366)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1555",
    "data-name": "Rectangle 1555",
    width: 63.099,
    height: 65.771,
    transform: "translate(39.051 14.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10785",
    "data-name": "Path 10785",
    d: "M67.566,112.49a10.852,10.852,0,0,1-1.53,1.806c-1,1.066-2.421,2.509-4,4.064s-3.048,2.961-4.127,3.952A11.29,11.29,0,0,1,56,123.83a9.383,9.383,0,0,1,1.543-1.806c1.016-1.066,2.434-2.509,4.027-4.077S64.618,114.986,65.7,114A9.384,9.384,0,0,1,67.566,112.49Z",
    transform: "translate(-28.515 -31.465)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10786",
    "data-name": "Path 10786",
    d: "M115.52,112.36a10.324,10.324,0,0,1,1.857,1.556c1.066,1,2.509,2.421,4.064,4s2.961,3.048,3.952,4.127a10.537,10.537,0,0,1,1.518,1.819,9.383,9.383,0,0,1-1.806-1.543c-1.066-1-2.509-2.421-4.077-4.014s-2.961-3.061-3.952-4.14A9.144,9.144,0,0,1,115.52,112.36Z",
    transform: "translate(-13.37 -31.498)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10787",
    "data-name": "Path 10787",
    d: "M115.38,62.14a10.487,10.487,0,0,1,1.556-1.806c1-1.066,2.421-2.509,4.014-4.064s3.048-2.961,4.115-3.952A9.785,9.785,0,0,1,126.9,50.8a10.324,10.324,0,0,1-1.556,1.806c-1,1.066-2.421,2.509-4.014,4.077s-3.061,2.961-4.127,3.952a9.384,9.384,0,0,1-1.819,1.505Z",
    transform: "translate(-13.405 -47.162)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10788",
    "data-name": "Path 10788",
    d: "M67.39,62.344a9.961,9.961,0,0,1-1.806-1.556c-1.066-1-2.509-2.421-4.077-4.014s-3-3.086-3.939-4.152A9.183,9.183,0,0,1,56,50.79a10.035,10.035,0,0,1,1.844,1.518c1.066,1,2.509,2.421,4.077,4.014s2.973,3.061,3.952,4.127A9.834,9.834,0,0,1,67.39,62.344Z",
    transform: "translate(-28.515 -47.165)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10789",
    "data-name": "Path 10789",
    d: "M128.2,125.54v-4.792c0-3.111,0-7.652-.075-13.41,0-11.516,0-27.924-.113-47.582l.238.251H65.326l.276-.276v65.784l-.238-.238,45.562.113h17.061a1.166,1.166,0,0,1,.3,0H111.076l-45.712.125H65V59.48h63.45v.238c0,19.72-.088,36.179-.113,47.745,0,5.733,0,10.249-.075,13.347V125.2A2.72,2.72,0,0,1,128.2,125.54Z",
    transform: "translate(-26.225 -44.953)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1556",
    "data-name": "Rectangle 1556",
    width: 21.05,
    height: 21.05,
    transform: "translate(60.063 37.17)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1557",
    "data-name": "Rectangle 1557",
    width: 97.17,
    height: 140.85,
    transform: "translate(748.333)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1558",
    "data-name": "Rectangle 1558",
    width: 97.17,
    height: 140.85,
    transform: "translate(743.466)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1559",
    "data-name": "Rectangle 1559",
    width: 73.034,
    height: 110.342,
    transform: "translate(755.547 15.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10790",
    "data-name": "Path 10790",
    d: "M709.43,170.446v-8.154c0-5.294,0-13-.075-22.731,0-19.457,0-47.017-.113-79.457l.238.238H636.458l.263-.263c0,41.623,0,80.009-.063,110.392l-.2-.213,53.151.113h.213l-53.277.113h-.213v-.038c0-30.333,0-68.719-.063-110.392V59.79h73.536v.238c0,32.516-.088,60.114-.113,79.62,0,9.71,0,17.4-.063,22.668v7.539A.988.988,0,0,1,709.43,170.446Z",
    transform: "translate(119.139 -44.875)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10791",
    "data-name": "Path 10791",
    d: "M707.115,47.9a16.544,16.544,0,0,1-1.731,2.509c-1.129,1.518-2.722,3.563-4.554,5.783s-3.538,4.19-4.8,5.595a17.261,17.261,0,0,1-2.145,2.183,18.3,18.3,0,0,1,1.857-2.434l4.679-5.67,4.679-5.683a19.55,19.55,0,0,1,2.02-2.283Z",
    transform: "translate(133.798 -47.9)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10792",
    "data-name": "Path 10792",
    d: "M694.89,147.74a91.014,91.014,0,0,0,12.683,15.932",
    transform: "translate(134.055 -22.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10793",
    "data-name": "Path 10793",
    d: "M707.583,163.672a15.691,15.691,0,0,1-2.22-2.032,66.494,66.494,0,0,1-4.8-5.419,69.1,69.1,0,0,1-4.228-5.871,13.708,13.708,0,0,1-1.48-2.609,19.717,19.717,0,0,1,1.794,2.4c1.066,1.505,2.509,3.563,4.328,5.758s3.437,4.115,4.667,5.495a18.253,18.253,0,0,1,1.945,2.283Z",
    transform: "translate(134.045 -22.495)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10794",
    "data-name": "Path 10794",
    d: "M626.74,163.276l12.733-15.706",
    transform: "translate(116.714 -22.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10795",
    "data-name": "Path 10795",
    d: "M639.468,147.57a94.642,94.642,0,0,1-6.134,8.066,96.854,96.854,0,0,1-6.573,7.69,99.577,99.577,0,0,1,6.159-8.016,96.577,96.577,0,0,1,6.548-7.74Z",
    transform: "translate(116.719 -22.538)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10796",
    "data-name": "Path 10796",
    d: "M626.75,47.9a87.249,87.249,0,0,1,6.184,7.389A84.513,84.513,0,0,1,638.693,63a88.327,88.327,0,0,1-6.172-7.389A90.7,90.7,0,0,1,626.75,47.9Z",
    transform: "translate(116.716 -47.9)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1560",
    "data-name": "Rectangle 1560",
    width: 24.449,
    height: 69.434,
    transform: "translate(781.363 37.659)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10797",
    "data-name": "Path 10797",
    d: "M65.107,253.379a41.962,41.962,0,0,0-17.939-6.172c-2.935-.3-6.134-.213-8.48,1.568a1.731,1.731,0,0,0-.878,1.543,1.907,1.907,0,0,0,.828,1.066,25.654,25.654,0,0,0,26.469,1.995",
    transform: "translate(-33.143 2.781)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10798",
    "data-name": "Path 10798",
    d: "M63.078,257.4a87.146,87.146,0,0,1-11.554-10.2,29.266,29.266,0,0,1-7.263-13.435,5.419,5.419,0,0,1,.565-4.491c9.208,7.175,16.458,16.546,18.252,28.125",
    transform: "translate(-31.566 -1.747)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10799",
    "data-name": "Path 10799",
    d: "M59.621,257.681a41.623,41.623,0,0,1,.213-15.217,20.56,20.56,0,0,1,8.1-12.545c1.593,3.763.9,8.029-.213,11.93a58.144,58.144,0,0,1-8.041,16.923",
    transform: "translate(-27.746 -1.584)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10800",
    "data-name": "Path 10800",
    d: "M71.3,265c-5.495.665-10.274,3.563-14.376,7.288a27.2,27.2,0,0,0-8.242,14.125c5.394-.339,10.036-4.14,13.285-8.4s5.62-8.932,9.258-12.921",
    transform: "translate(-30.377 7.342)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10801",
    "data-name": "Path 10801",
    d: "M68.781,273.859a35.476,35.476,0,0,1,4.1-33.569c3.124,11.14,1.982,23.722-4.1,33.569",
    transform: "translate(-25.891 1.055)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10802",
    "data-name": "Path 10802",
    d: "M82.873,278.42a25.629,25.629,0,0,0-24.537,14.125c-.3.6-.577,1.38-.163,1.919a1.819,1.819,0,0,0,1.631.477c4.83-.314,9.12-3.224,12.657-6.536s6.611-7.138,10.525-10.036",
    transform: "translate(-28.015 10.744)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10803",
    "data-name": "Path 10803",
    d: "M77.938,284.684a45.662,45.662,0,0,1-.464-25.528c.9-3.287,2.409-6.749,5.444-8.279a1.066,1.066,0,0,1,.84-.151,1.167,1.167,0,0,1,.527.615,15.355,15.355,0,0,1,1.254,7.313,46.239,46.239,0,0,1-1.142,7.414c-.966,4.529-1.468,9.408-3.952,13.31a26.346,26.346,0,0,0-1.581,2.923c-.477.991-.477,1.342-.9,2.133",
    transform: "translate(-23.457 3.703)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10804",
    "data-name": "Path 10804",
    d: "M102.938,287.253c-2.346-8.919.151-19.745,5.77-27.059.414-.539.966-1.116,1.643-1.054,1.029.088,1.254,1.468,1.254,2.509a48.923,48.923,0,0,1-8.668,25.6",
    transform: "translate(-16.795 5.85)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10805",
    "data-name": "Path 10805",
    d: "M105,285.008a39.377,39.377,0,0,0,32.29-6.573,26.08,26.08,0,0,0-17.475-2.145c-5.846,1.33-11.19,3.951-14.815,8.718",
    transform: "translate(-16.047 10.052)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10806",
    "data-name": "Path 10806",
    d: "M107,281.808c6.072-9.9,17.713-16.371,29.3-16.948-1.33,4.717-5.206,8.38-9.584,10.6s-9.258,3.174-14.075,4.115c-1.869.364-4.441.765-5.645,2.233",
    transform: "translate(-15.538 7.307)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10807",
    "data-name": "Path 10807",
    d: "M104.094,262.306a85.3,85.3,0,0,0,3.763-17.161c.452-5.858-.389-11.967-3.425-16.985-5.67,10.977-6.272,23.835-.489,34.736",
    transform: "translate(-17.348 -2.032)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10808",
    "data-name": "Path 10808",
    d: "M118.47,252.364c6.624-12.055,20.159-21.69,33.87-23.044-5.281,13.159-19.695,23.32-33.87,23.044",
    transform: "translate(-12.619 -1.737)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10809",
    "data-name": "Path 10809",
    d: "M115.14,249.971c9.885,1.505,18.315,7.828,27.6,11.654a12.168,12.168,0,0,0,6.272,1.192,4.88,4.88,0,0,0,3.061-8.631,13.234,13.234,0,0,0-4.529-2.735c-10.036-4.2-20.874-4.3-31.474-1.756",
    transform: "translate(-13.466 3.015)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10810",
    "data-name": "Path 10810",
    d: "M110.57,255.2c2.245.64,3.011,1.806,4.779,3.312a51.507,51.507,0,0,0,20.912,10.738c.79.2,1.844.276,2.245-.439s-.1-1.392-.552-1.957a28.651,28.651,0,0,0-12.62-8.568c-4.817-1.794-9.007-3.964-14.765-3.5",
    transform: "translate(-14.629 4.727)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10811",
    "data-name": "Path 10811",
    d: "M105.42,221.906a39.578,39.578,0,0,0,30.333,10.324,2.107,2.107,0,0,0,1.38-.489c.765-.84-.151-2.12-1.041-2.81-8.919-6.95-19.72-9.835-30.671-7.025",
    transform: "translate(-15.94 -3.894)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10812",
    "data-name": "Path 10812",
    d: "M111.53,221.133a42.275,42.275,0,0,1,37.847-6.272,29.982,29.982,0,0,1-18.039,7.916,56.777,56.777,0,0,1-19.808-1.668",
    transform: "translate(-14.385 -5.918)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10813",
    "data-name": "Path 10813",
    d: "M110.136,209.541c-.866-8.907-.3-15.932-.916-24.876,0-.715-.213-1.568-.878-1.832-.928-.351-1.706.79-2.007,1.744A28.514,28.514,0,0,0,110.1,209.34",
    transform: "translate(-16.039 -13.582)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10814",
    "data-name": "Path 10814",
    d: "M108.59,210.564a52.411,52.411,0,0,0,14.752-14.326c2.91-3.989,5.369-8.781,4.7-13.648a14.088,14.088,0,0,0-10.638,5.281,29.668,29.668,0,0,0-5.419,10.9c-1.179,3.926-2.007,7.941-3.4,11.792",
    transform: "translate(-15.133 -13.627)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10815",
    "data-name": "Path 10815",
    d: "M120.176,206.2a118.734,118.734,0,0,0,36.291-21.389c-4.34-1.744-9.308-.7-13.636,1.041A43.028,43.028,0,0,0,120,206.113",
    transform: "translate(-12.23 -13.29)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10816",
    "data-name": "Path 10816",
    d: "M111.843,210.9c6.7.74,13.5,1.254,20.147.1s12.708-3.676,18.817-6.272a2.17,2.17,0,0,0,1.254-.966,1.468,1.468,0,0,0-.452-1.618,4.039,4.039,0,0,0-1.606-.753c-6.636-1.844-13.8-.978-20.322,1.254a94.459,94.459,0,0,0-17.851,8.267",
    transform: "translate(-14.309 -9.098)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10817",
    "data-name": "Path 10817",
    d: "M82.031,227.925c-4.566-9.233-4.278-20-.326-29.5,2.785,4.24,3.124,9.634,2.609,14.665s-2.045,10.236-2.133,15.292",
    transform: "translate(-22.745 -9.599)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10818",
    "data-name": "Path 10818",
    d: "M73,214.6A41.083,41.083,0,0,0,42.43,227.647a28.551,28.551,0,0,0,16.734-3.111,84.7,84.7,0,0,0,14.351-9.6",
    transform: "translate(-31.968 -5.483)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10819",
    "data-name": "Path 10819",
    d: "M62.83,211.429c-5.582-.452-10.951-1.142-16.308.5a19.62,19.62,0,0,0-12.432,10.55,29.492,29.492,0,0,0,15.3-2.885,87.159,87.159,0,0,0,13.435-8.167",
    transform: "translate(-34.09 -6.426)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10820",
    "data-name": "Path 10820",
    d: "M78.139,213.208c-5.018-3.287-10.174-6.636-16.019-8s-12.632-.351-16.709,4.052c4.742,2.785,10.475,3.111,15.969,3.111s12.218-.075,17.387,1.756",
    transform: "translate(-31.21 -8.017)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10821",
    "data-name": "Path 10821",
    d: "M73.495,218.815c-8.58-8.43-11.83-23.584-8.38-35.125a53.415,53.415,0,0,1,8.38,35.125",
    transform: "translate(-26.541 -13.347)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10822",
    "data-name": "Path 10822",
    d: "M90.34,198.258c1.618-3.763,2.76-7.715,4.215-11.554a33.117,33.117,0,0,1,6-10.588,15.794,15.794,0,0,1,10.638-5.507,42.827,42.827,0,0,1-20.636,27.749",
    transform: "translate(-19.777 -16.676)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10823",
    "data-name": "Path 10823",
    d: "M91.446,199.677c-2.685-3.688-5.783-8.693-9.408-11.441s-8.367-4.416-12.808-3.362a29.781,29.781,0,0,0,22.216,14.8",
    transform: "translate(-25.148 -13.127)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10824",
    "data-name": "Path 10824",
    d: "M88.55,198.5a63.978,63.978,0,0,1-4.24-13.661,21.476,21.476,0,0,1,2.208-14c4.717,8.907,6.272,18.466,2.333,27.761",
    transform: "translate(-21.399 -16.617)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10825",
    "data-name": "Path 10825",
    d: "M90.383,174.665c2.659-8.781,10.751-15.329,19.482-18.315a7.276,7.276,0,0,1,3.412-.514,2.96,2.96,0,0,1,2.509,2.107c.314,1.505-.928,2.848-2.095,3.839a66.324,66.324,0,0,1-23.32,12.883",
    transform: "translate(-19.769 -20.443)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10826",
    "data-name": "Path 10826",
    d: "M90.486,171.11c.339-5.7.7-11.478,2.509-16.872s5.419-10.45,10.613-12.808c.891,5.745-1.656,11.466-4.7,16.408s-6.749,9.622-8.593,15.141",
    transform: "translate(-19.784 -24.101)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10827",
    "data-name": "Path 10827",
    d: "M93.693,174.49c-2.208-6.435-2.434-14.614-6.272-20.222-2.7-3.914-7.012-6.586-9.333-10.738a16.308,16.308,0,0,0,.552,12.193,35.25,35.25,0,0,0,7.1,10.211c2.848,3.036,5.294,5.331,7.941,8.555",
    transform: "translate(-23.13 -23.566)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10828",
    "data-name": "Path 10828",
    d: "M90.449,358.189c-.176,0-.326-42.94-.339-95.878s.113-95.891.289-95.891.326,42.927.339,95.891S90.612,358.189,90.449,358.189Z",
    transform: "translate(-19.836 -17.742)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10829",
    "data-name": "Path 10829",
    d: "M127.9,216.77a8,8,0,0,1-1.606.615l-4.453,1.493c-3.763,1.254-8.882,3.124-14.464,5.419s-10.751,4.29-13.724,6.862a10.035,10.035,0,0,0-2.747,3.65c-.427,1-.5,1.618-.564,1.606s0-.151,0-.439a6.184,6.184,0,0,1,.314-1.254,9.684,9.684,0,0,1,2.685-3.889,24.55,24.55,0,0,1,5.971-3.738c2.383-1.1,5.018-2.271,7.828-3.412,5.595-2.3,10.788-4.09,14.577-5.256,1.882-.59,3.437-1.029,4.5-1.317a10.4,10.4,0,0,1,1.681-.339Z",
    transform: "translate(-19.782 -4.93)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10830",
    "data-name": "Path 10830",
    d: "M139.609,192.69a5.732,5.732,0,0,1-.464.489l-1.367,1.254-5.143,4.679L115.511,214.4c-6.674,5.959-12.457,11.641-16.458,15.919-2.007,2.133-3.575,3.9-4.654,5.143l-1.254,1.418c-.289.326-.452.489-.464.464a2.053,2.053,0,0,1,.364-.539c.263-.339.64-.866,1.154-1.505,1.029-1.254,2.509-3.1,4.516-5.281a220.62,220.62,0,0,1,16.308-16.07c6.711-5.934,12.808-11.29,17.249-15.116l5.269-4.516,1.455-1.254a2.847,2.847,0,0,1,.615-.376Z",
    transform: "translate(-19.182 -11.057)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10831",
    "data-name": "Path 10831",
    d: "M105.133,217.833c-.176-.088,1.254-3.312,2.609-7.376s2.07-7.527,2.245-7.527a25.278,25.278,0,0,1-1.656,7.677,52.2,52.2,0,0,1-2.107,5.206,8.591,8.591,0,0,1-1.091,2.02Z",
    transform: "translate(-16.016 -8.452)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10832",
    "data-name": "Path 10832",
    d: "M95.458,241.887a7.4,7.4,0,0,1-1.029-1.254l-2.647-3.387c-2.208-2.86-5.269-6.812-8.706-11.14s-6.586-8.217-8.882-11.014l-2.7-3.337a9.006,9.006,0,0,1-.928-1.254,8.078,8.078,0,0,1,1.116,1.116c.69.753,1.656,1.844,2.848,3.211,2.371,2.735,5.582,6.586,9.032,10.914s6.448,8.33,8.568,11.29c1.066,1.468,1.919,2.659,2.509,3.5a8.331,8.331,0,0,1,.815,1.355Z",
    transform: "translate(-24.807 -6.525)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10833",
    "data-name": "Path 10833",
    d: "M84.714,229.726a15.141,15.141,0,0,1-3.45-6.4,18.716,18.716,0,0,1-.778-6.511h.276c-.125.5-.213.765-.263.753s0-.289,0-.79h.276a29.469,29.469,0,0,0,1.1,6.272,47.03,47.03,0,0,0,2.835,6.674Z",
    transform: "translate(-22.292 -4.927)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10834",
    "data-name": "Path 10834",
    d: "M79.148,216.987a10.788,10.788,0,0,0-2.4-1.392,16.045,16.045,0,0,0-6.686-.539,41.983,41.983,0,0,0-6.724,1.091,19.305,19.305,0,0,1-2.772.665,9.812,9.812,0,0,1,2.647-1.091,31.36,31.36,0,0,1,6.8-1.254,14.74,14.74,0,0,1,6.9.74,4.24,4.24,0,0,1,2.233,1.781Z",
    transform: "translate(-27.352 -5.548)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10835",
    "data-name": "Path 10835",
    d: "M78.678,214.67c0,.1-1.4-.565-3.688-1.342a38.537,38.537,0,0,0-9.2-1.894,38.072,38.072,0,0,0-9.383.477c-2.371.427-3.763.878-3.851.765a4.2,4.2,0,0,1,.978-.414,22,22,0,0,1,2.785-.778,32.842,32.842,0,0,1,18.817,1.43,25.3,25.3,0,0,1,2.634,1.192,3.639,3.639,0,0,1,.9.565Z",
    transform: "translate(-29.39 -6.468)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10836",
    "data-name": "Path 10836",
    d: "M91.309,206.817a77.3,77.3,0,0,1-2.685-9.346A78.3,78.3,0,0,1,86.53,188a72.756,72.756,0,0,1,2.7,9.333A76.6,76.6,0,0,1,91.309,206.817Z",
    transform: "translate(-20.746 -12.251)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10837",
    "data-name": "Path 10837",
    d: "M91.974,205.053a46.72,46.72,0,0,0-2.986-5.595,25.753,25.753,0,0,0-4.378-4.529,4.115,4.115,0,0,1,1.694.878,13.9,13.9,0,0,1,3.2,3.3,12.406,12.406,0,0,1,2.471,5.946Z",
    transform: "translate(-21.235 -10.487)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10838",
    "data-name": "Path 10838",
    d: "M98.357,313.71c-.075,0-.2-1.029-.677-2.848a41.108,41.108,0,0,0-2.873-7.439c-2.973-6.059-8.367-13.8-15.217-21.439-3.4-3.889-6.7-7.527-9.5-11.052a76.884,76.884,0,0,1-6.787-9.8,47.82,47.82,0,0,1-3.437-7.263c-.314-.891-.539-1.593-.665-2.082a2.885,2.885,0,0,1-.176-.74s.364.991,1.066,2.735a54.381,54.381,0,0,0,3.588,7.238,82.572,82.572,0,0,0,6.849,9.647c2.81,3.475,6.109,7.113,9.521,11,6.874,7.715,12.256,15.505,15.141,21.664a36.38,36.38,0,0,1,2.71,7.527,21.6,21.6,0,0,1,.389,2.158,4.217,4.217,0,0,1,.063.69Z",
    transform: "translate(-27.744 3.793)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10839",
    "data-name": "Path 10839",
    d: "M124.275,270.521a15.424,15.424,0,0,1-1.781.991,40.409,40.409,0,0,0-4.6,3.048,52.45,52.45,0,0,0-6.046,5.52c-2.133,2.245-4.315,4.855-6.548,7.64-4.466,5.607-8.643,10.563-11.14,14.527a54.121,54.121,0,0,0-2.8,4.779,17.032,17.032,0,0,1-.978,1.781,1.278,1.278,0,0,1,.163-.5c.163-.326.314-.8.59-1.392a46.194,46.194,0,0,1,2.647-4.9c2.434-4.052,6.573-9.082,11.027-14.677,2.245-2.8,4.453-5.407,6.624-7.64a48.984,48.984,0,0,1,6.2-5.482,32.234,32.234,0,0,1,4.754-2.91c.59-.289,1.079-.477,1.392-.615S124.263,270.5,124.275,270.521Z",
    transform: "translate(-19.767 8.746)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10840",
    "data-name": "Path 10840",
    d: "M122.686,280.429a26.729,26.729,0,0,1-3.763.552,48.394,48.394,0,0,0-8.907,1.744,27.109,27.109,0,0,0-7.978,4.19c-1.844,1.418-2.71,2.6-2.8,2.509a3.024,3.024,0,0,1,.564-.853,13.973,13.973,0,0,1,1.957-2.007,24.236,24.236,0,0,1,8.054-4.441,40.317,40.317,0,0,1,9.057-1.593A20.95,20.95,0,0,1,122.686,280.429Z",
    transform: "translate(-17.512 11.257)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10841",
    "data-name": "Path 10841",
    d: "M100.133,289.1c-.2-.113,1.493-2.7,2.81-6.172s1.518-6.586,1.744-6.561a6.272,6.272,0,0,1-.063,2.02,21.739,21.739,0,0,1-1.1,4.742,22.906,22.906,0,0,1-2.17,4.353A6.587,6.587,0,0,1,100.133,289.1Z",
    transform: "translate(-17.289 10.236)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10842",
    "data-name": "Path 10842",
    d: "M135.252,243.93a2.244,2.244,0,0,1-.6.326l-1.756.8c-.778.326-1.719.753-2.772,1.254s-2.3,1.116-3.588,1.882l-2.045,1.167c-.715.414-1.418.9-2.17,1.367-1.505.916-3.023,2.045-4.629,3.2a79.032,79.032,0,0,0-17.863,18.478c-1.1,1.656-2.183,3.211-3.036,4.742-.452.765-.9,1.493-1.254,2.208l-1.091,2.095c-.728,1.254-1.254,2.572-1.769,3.65s-.9,2.02-1.254,2.81-.552,1.317-.74,1.794a4.053,4.053,0,0,1-.3.6,2.51,2.51,0,0,1,.176-.652c.163-.477.376-1.091.64-1.831a29.6,29.6,0,0,1,1.116-2.86c.477-1.1.978-2.383,1.694-3.763l1.054-2.12c.376-.728.828-1.468,1.254-2.233.853-1.568,1.919-3.136,3.011-4.817a76.7,76.7,0,0,1,17.989-18.616c1.643-1.142,3.174-2.271,4.7-3.174.765-.464,1.48-.941,2.2-1.342l2.082-1.129c1.254-.753,2.509-1.254,3.65-1.819s2.032-.916,2.823-1.254l1.819-.69A3.2,3.2,0,0,1,135.252,243.93Z",
    transform: "translate(-19.767 1.981)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10843",
    "data-name": "Path 10843",
    d: "M104.76,259.168a4.479,4.479,0,0,1,1.48-2.2,9.383,9.383,0,0,1,5.946-2.283,16.408,16.408,0,0,1,6.272,1.254,9.422,9.422,0,0,1,2.358,1.142,14.276,14.276,0,0,1-2.509-.728,19.069,19.069,0,0,0-6.1-1.016,9.622,9.622,0,0,0-5.67,1.995,19.313,19.313,0,0,0-1.781,1.831Z",
    transform: "translate(-16.108 4.719)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10844",
    "data-name": "Path 10844",
    d: "M101.57,263.837a15.944,15.944,0,0,0,1.254-11.227,3.763,3.763,0,0,1,.7,1.606,11.44,11.44,0,0,1-.966,8.229C102.109,263.4,101.633,263.888,101.57,263.837Z",
    transform: "translate(-16.919 4.19)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10845",
    "data-name": "Path 10845",
    d: "M66.74,306c.928,16.4,5.871,33.093,13.473,49.952H113.28c7.251-16.7,11.855-33.356,12.67-49.952Z",
    transform: "translate(-25.782 17.775)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10846",
    "data-name": "Path 10846",
    d: "M119.535,327.174c0,.176-10.889.314-24.311.314s-24.324-.138-24.324-.314,10.889-.314,24.324-.314S119.535,327.036,119.535,327.174Z",
    transform: "translate(-24.723 23.083)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10847",
    "data-name": "Path 10847",
    d: "M118.327,331.914c0,.163-10.2.3-22.793.3s-22.793-.138-22.793-.3,10.2-.314,22.793-.314S118.327,331.738,118.327,331.914Z",
    transform: "translate(-24.255 24.289)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10848",
    "data-name": "Path 10848",
    d: "M77.974,314.53a96.6,96.6,0,0,1,0,15.242,92.755,92.755,0,0,1,0-15.242Z",
    transform: "translate(-23.003 19.946)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10849",
    "data-name": "Path 10849",
    d: "M92.064,314.53a99.414,99.414,0,0,1,0,15.781,99.418,99.418,0,0,1,0-15.781Z",
    transform: "translate(-19.418 19.946)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10850",
    "data-name": "Path 10850",
    d: "M105.362,314.43a51.431,51.431,0,0,1,.314,8.041,51.433,51.433,0,0,1-.314,8.041,51.435,51.435,0,0,1-.314-8.041A51.434,51.434,0,0,1,105.362,314.43Z",
    transform: "translate(-16.044 19.92)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10851",
    "data-name": "Path 10851",
    d: "M124.68,314.591c0,.176-12.77.314-28.526.314s-28.514-.138-28.514-.314,12.758-.3,28.514-.3S124.68,314.428,124.68,314.591Z",
    transform: "translate(-25.553 19.885)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1561",
    "data-name": "Rectangle 1561",
    width: 83.911,
    height: 87.461,
    transform: "translate(758.306 173.228)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1562",
    "data-name": "Rectangle 1562",
    width: 83.911,
    height: 87.461,
    transform: "translate(752.624 173.228)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10852",
    "data-name": "Path 10852",
    d: "M718.049,273.486H634V186h84.049Zm-83.9,0H718V186H634.1Z",
    transform: "translate(118.561 -12.76)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1563",
    "data-name": "Rectangle 1563",
    width: 61.343,
    height: 63.952,
    transform: "translate(763.914 184.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10853",
    "data-name": "Path 10853",
    d: "M645.322,246.68a10.8,10.8,0,0,1-1.518,1.769c-.979,1.029-2.358,2.434-3.9,3.952s-2.961,2.873-4,3.839a10.315,10.315,0,0,1-1.781,1.468,10.035,10.035,0,0,1,1.505-1.744c.979-1.041,2.358-2.509,3.914-3.964s2.961-2.885,4.014-3.851A10.034,10.034,0,0,1,645.322,246.68Z",
    transform: "translate(118.591 2.681)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10854",
    "data-name": "Path 10854",
    d: "M692,246.56a9.81,9.81,0,0,1,1.756,1.505c1.041.991,2.434,2.358,3.952,3.9s2.885,2.961,3.839,4.014a9.808,9.808,0,0,1,1.48,1.769,10.359,10.359,0,0,1-1.756-1.505c-1.029-.978-2.434-2.358-3.964-3.9s-2.873-2.973-3.839-4.027A8.947,8.947,0,0,1,692,246.56Z",
    transform: "translate(133.319 2.65)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10855",
    "data-name": "Path 10855",
    d: "M691.82,197.737a9.809,9.809,0,0,1,1.505-1.756c.979-1.029,2.358-2.434,3.9-3.952s2.961-2.873,4.014-3.839a9.812,9.812,0,0,1,1.769-1.48,9.319,9.319,0,0,1-1.505,1.756c-.979,1.029-2.358,2.434-3.914,3.964s-2.96,2.873-4.014,3.839a9.4,9.4,0,0,1-1.756,1.468Z",
    transform: "translate(133.274 -12.579)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10856",
    "data-name": "Path 10856",
    d: "M645.147,197.9a10.316,10.316,0,0,1-1.756-1.518c-1.041-.978-2.434-2.358-3.952-3.9s-2.873-2.961-3.839-4a9.6,9.6,0,0,1-1.48-1.781,9.807,9.807,0,0,1,1.756,1.505c1.029.991,2.434,2.371,3.964,3.914s2.873,2.973,3.839,4.014a8.779,8.779,0,0,1,1.468,1.769Z",
    transform: "translate(118.591 -12.581)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10857",
    "data-name": "Path 10857",
    d: "M704.255,259.4a1.38,1.38,0,0,1,0-.3c0-.226,0-.514,0-.9V241.716c0-11.2-.063-27.146-.113-46.252l.238.238H643.2l.263-.263v63.977l-.226-.226,44.295.113,12.444.063H687.634l-44.445.125h-.238V195h61.531v.238c0,19.168-.088,35.125-.113,46.415v17.261A1.489,1.489,0,0,1,704.255,259.4Z",
    transform: "translate(120.838 -10.469)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1564",
    "data-name": "Rectangle 1564",
    width: 20.473,
    height: 20.473,
    transform: "translate(784.349 206.734)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10858",
    "data-name": "Path 10858",
    d: "M467.52,429.13v39.678H589.541V429.13Z",
    transform: "translate(76.199 49.106)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10859",
    "data-name": "Path 10859",
    d: "M463.44,420.29v11.089H594.857V420.29H463.44Z",
    transform: "translate(75.161 46.857)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10860",
    "data-name": "Path 10860",
    d: "M516.342,471.058h61.431V431.379h4.278V420.29H513.77v10.061Z",
    transform: "translate(87.968 46.857)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1565",
    "data-name": "Rectangle 1565",
    width: 24.75,
    height: 5.971,
    transform: "translate(560.78 484.634)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1566",
    "data-name": "Rectangle 1566",
    width: 31.775,
    height: 12.607,
    transform: "translate(557.593 498.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10861",
    "data-name": "Path 10861",
    d: "M482.48,388.7v39.678H604.513V388.7Z",
    transform: "translate(80.006 38.819)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10862",
    "data-name": "Path 10862",
    d: "M478.4,379.85v11.1H609.817v-11.1H478.4Z",
    transform: "translate(78.967 36.567)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10863",
    "data-name": "Path 10863",
    d: "M531.3,430.63h61.443V390.952h4.265v-11.1H528.74v10.073Z",
    transform: "translate(91.777 36.567)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1567",
    "data-name": "Rectangle 1567",
    width: 24.75,
    height: 5.971,
    transform: "translate(579.559 433.916)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1568",
    "data-name": "Rectangle 1568",
    width: 31.775,
    height: 12.607,
    transform: "translate(576.372 447.352)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-35",
    transform: "translate(42.106 423.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10864",
    "data-name": "Path 10864",
    d: "M872,347.066c0,.176-186.161.326-415.739.326s-415.777-.163-415.777-.326,186.111-.326,415.777-.326S872,346.878,872,347.066Z",
    transform: "translate(-40.48 -346.74)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10865",
    "data-name": "Path 10865",
    d: "M850.524,461.166c0,.176-178.133.326-397.888.326s-397.926-.151-397.926-.326,178.133-.326,397.926-.326S850.524,461.041,850.524,461.166Z",
    transform: "translate(-36.859 -317.707)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-35",
    transform: "translate(174.923 46.73)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1569",
    "data-name": "Rectangle 1569",
    width: 556.339,
    height: 367.907,
    rx: 14.57,
    transform: "translate(22.008 0.326)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10866",
    "data-name": "Path 10866",
    d: "M702.024,414.963l1.192-.075a8.78,8.78,0,0,0,1.443-.163,11.815,11.815,0,0,0,1.995-.414,16.961,16.961,0,0,0,5.256-2.321,17.976,17.976,0,0,0,5.532-5.632,18.9,18.9,0,0,0,1.994-4.278,19.961,19.961,0,0,0,.778-5.244c0-3.763,0-7.815,0-12.243V354.047c0-45.976,0-112.512-.1-194.717v-90.2a31.048,31.048,0,0,0-.665-8.568,18.014,18.014,0,0,0-11.416-12.218,17.565,17.565,0,0,0-2.107-.6c-.715-.151-1.443-.251-2.17-.339-1.468-.1-2.961-.088-4.466-.075H182.3a18.027,18.027,0,0,0-17.236,12.833,19.569,19.569,0,0,0-.753,5.67V395.293a24.462,24.462,0,0,0,.376,5.018,18.177,18.177,0,0,0,4.554,8.681,17.562,17.562,0,0,0,3.851,3.074,19.953,19.953,0,0,0,2.183,1.129,18.817,18.817,0,0,0,2.333.778c3.161.928,6.511.577,9.822.64H435.992l194.692.113,52.938.063h0l-52.938.063-194.692.1H182.416a18.815,18.815,0,0,1-5.018-.652,20.843,20.843,0,0,1-2.409-.8,22.735,22.735,0,0,1-2.258-1.179,17.85,17.85,0,0,1-3.964-3.174,18.254,18.254,0,0,1-2.973-4.14,19.947,19.947,0,0,1-1.744-4.817,25.092,25.092,0,0,1-.389-5.118V65.886a19.759,19.759,0,0,1,.778-5.858A18.679,18.679,0,0,1,182.3,46.73H699.227c1.505,0,2.986,0,4.5.088a22.583,22.583,0,0,1,2.245.339,18.7,18.7,0,0,1,13.912,13.209l.276,1.066c.075.364.113.728.176,1.091a16.233,16.233,0,0,1,.2,2.2c0,1.468,0,2.91,0,4.353V159.2c0,82.2-.088,148.741-.113,194.717v42.79a19.818,19.818,0,0,1-.8,5.294,18.527,18.527,0,0,1-2.02,4.353,17.952,17.952,0,0,1-5.595,5.658,17.049,17.049,0,0,1-5.281,2.3,12.3,12.3,0,0,1-2.007.4,8.6,8.6,0,0,1-1.455.138Z",
    transform: "translate(-141.955 -46.73)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10867",
    "data-name": "Path 10867",
    d: "M726.994,353.529H168.887A22.329,22.329,0,0,1,146.57,331.2v-9.86H749.324v9.86A22.329,22.329,0,0,1,726.994,353.529Z",
    transform: "translate(-146.302 23.146)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10868",
    "data-name": "Path 10868",
    d: "M727.049,353.585h.728a20.924,20.924,0,0,0,2.145-.188l1.593-.251,1.894-.489c.69-.2,1.392-.5,2.17-.778a15.526,15.526,0,0,0,2.383-1.179,23.361,23.361,0,0,0,5.018-3.851,22.3,22.3,0,0,0,6.272-15.053c0-3.224,0-6.686,0-10.362l.125.113-580.4.213H146.624l.326-.326v7.84a26.154,26.154,0,0,0,.753,7.677A21.928,21.928,0,0,0,156.3,349.27,22.881,22.881,0,0,0,170.71,353.3H359.719l191.581.075,128.682.1,34.911.063H679.982l-128.682.1-191.581.075H170.71a23.534,23.534,0,0,1-14.765-3.889,22.58,22.58,0,0,1-8.781-12.7,27.1,27.1,0,0,1-.778-7.84V321.12h22.681l580.4.2h.113v10.5a22.342,22.342,0,0,1-6.548,15.066,23.653,23.653,0,0,1-5.018,3.864c-.828.464-1.643.815-2.4,1.167a13.515,13.515,0,0,1-2.2.765l-1.907.477-1.593.238a16.49,16.49,0,0,1-2.158.151Z",
    transform: "translate(-146.356 23.09)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10869",
    "data-name": "Path 10869",
    d: "M341.93,321.33l7.477,11.892H454.655l6.937-11.892Z",
    transform: "translate(-96.591 23.144)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1570",
    "data-name": "Rectangle 1570",
    width: 504.379,
    height: 299.175,
    rx: 8.48,
    transform: "translate(47.749 25.465)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10870",
    "data-name": "Path 10870",
    d: "M678,366.271a11.477,11.477,0,0,0,3.989-.8,10.726,10.726,0,0,0,4.077-2.873,10.876,10.876,0,0,0,2.685-6.272c.075-10.563,0-26.181,0-46.277,0-40.143,0-98.349-.113-170.2V79.754a19.514,19.514,0,0,0-.176-3.65,10.538,10.538,0,0,0-3.55-6.2,10.676,10.676,0,0,0-6.736-2.509H195.382a10.588,10.588,0,0,0-8.543,4.34,10.237,10.237,0,0,0-1.882,4.541,42.07,42.07,0,0,0-.151,5.018V352.121c0,1.493,0,3.036.075,4.466a10.55,10.55,0,0,0,8.154,9.12,19.334,19.334,0,0,0,4.365.263H445.407l170.2.1,46.277.063h0l-46.277.063-170.2.1H197.4a19.4,19.4,0,0,1-4.491-.289,11.177,11.177,0,0,1-8.631-9.634c-.138-1.555,0-3.023-.075-4.529V81.359a41.992,41.992,0,0,1,.151-5.156,10.889,10.889,0,0,1,2.007-4.83,11.2,11.2,0,0,1,9.07-4.6H678.209A11.114,11.114,0,0,1,689,75.94a20.886,20.886,0,0,1,.176,3.763v60.139c0,71.855-.075,130.012-.1,170.2,0,20.071,0,35.7-.113,46.289a10.854,10.854,0,0,1-9.847,9.9Z",
    transform: "translate(-136.731 -41.631)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10871",
    "data-name": "Path 10871",
    d: "M335.917,128.62v2.873H324V116h11.692v2.873h-8.129v3.4h7.175v2.785h-7.175v3.575Z",
    transform: "translate(-101.154 -29.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10872",
    "data-name": "Path 10872",
    d: "M347.723,123.994v6.8h-3.45v-6.272c0-1.919-.878-2.81-2.409-2.81s-2.848,1.016-2.848,3.2v5.883H335.58v-11.88h3.287v1.4a5.206,5.206,0,0,1,3.926-1.568C345.6,118.726,347.723,120.319,347.723,123.994Z",
    transform: "translate(-98.207 -28.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10873",
    "data-name": "Path 10873",
    d: "M355.69,130.717a4.855,4.855,0,0,1-2.8.753c-2.81,0-4.441-1.43-4.441-4.265v-4.88H346.62v-2.647h1.831v-2.9h3.437v2.9h2.961v2.647h-2.961v4.842a1.393,1.393,0,0,0,1.493,1.568,2.3,2.3,0,0,0,1.38-.452Z",
    transform: "translate(-95.398 -28.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10874",
    "data-name": "Path 10874",
    d: "M366.857,125.832h-8.982a3.161,3.161,0,0,0,3.4,2.384,4,4,0,0,0,2.973-1.154l1.844,1.995a6.272,6.272,0,0,1-4.9,1.919c-4.115,0-6.787-2.584-6.787-6.122a6.059,6.059,0,0,1,6.335-6.122,5.883,5.883,0,0,1,6.184,6.172C366.92,125.167,366.882,125.543,366.857,125.832Zm-9.032-2.02h5.858a2.848,2.848,0,0,0-2.923-2.509,2.81,2.81,0,0,0-2.935,2.509Z",
    transform: "translate(-93.418 -28.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10875",
    "data-name": "Path 10875",
    d: "M373.6,118.732v3.186h-.778a2.923,2.923,0,0,0-3.161,3.312v5.607H366.22v-11.88h3.287v1.568a4.792,4.792,0,0,1,4.09-1.794Z",
    transform: "translate(-90.41 -28.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10876",
    "data-name": "Path 10876",
    d: "M386.839,126.036v5.482h-3.575v-5.482L377.28,116h3.763l4.14,6.874L389.31,116h3.512Z",
    transform: "translate(-87.596 -29.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10877",
    "data-name": "Path 10877",
    d: "M388.933,125.025a6.548,6.548,0,1,1,6.548,6.122,6.122,6.122,0,0,1-6.548-6.122Zm9.572,0a3.048,3.048,0,1,0-3.023,3.3,3,3,0,0,0,3.023-3.3Z",
    transform: "translate(-84.634 -28.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10878",
    "data-name": "Path 10878",
    d: "M413.163,118.88v11.88h-3.274v-1.418a4.8,4.8,0,0,1-3.688,1.593c-2.986,0-5.081-1.681-5.081-5.344V118.88h3.45v6.2c0,1.995.878,2.873,2.409,2.873s2.735-1.016,2.735-3.2V118.88Z",
    transform: "translate(-81.53 -28.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10879",
    "data-name": "Path 10879",
    d: "M420.646,118.732v3.186h-.765a2.91,2.91,0,0,0-3.161,3.312v5.607h-3.45v-11.88h3.287v1.568a4.792,4.792,0,0,1,4.09-1.794Z",
    transform: "translate(-78.438 -28.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10880",
    "data-name": "Path 10880",
    d: "M425.26,123.813c0-4.6,3.575-8,8.468-8s8.455,3.387,8.455,8-3.6,7.991-8.455,7.991S425.26,128.4,425.26,123.813Zm13.3,0a4.842,4.842,0,1,0-4.83,4.943,4.717,4.717,0,0,0,4.83-4.943Z",
    transform: "translate(-75.387 -29.152)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10881",
    "data-name": "Path 10881",
    d: "M444.285,118.948H439.33V116H452.8v2.923H447.86v12.545h-3.575Z",
    transform: "translate(-71.807 -29.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10882",
    "data-name": "Path 10882",
    d: "M465.02,121.645c0,3.437-2.584,5.582-6.724,5.582h-3.111v4.265H451.61V116H458.3C462.436,116,465.02,118.17,465.02,121.645Zm-3.625,0c0-1.706-1.1-2.7-3.3-2.7h-2.91v5.369h2.91C460.291,124.317,461.395,123.313,461.395,121.645Z",
    transform: "translate(-68.682 -29.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7796",
    "data-name": "Group 7796",
    transform: "translate(165.066 134.29)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1571",
    "data-name": "Rectangle 1571",
    width: 39.252,
    height: 53.477,
    rx: 5.47,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7797",
    "data-name": "Group 7797",
    transform: "translate(214.454 134.29)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1572",
    "data-name": "Rectangle 1572",
    width: 39.252,
    height: 53.477,
    rx: 5.47,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7798",
    "data-name": "Group 7798",
    transform: "translate(263.855 134.29)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1573",
    "data-name": "Rectangle 1573",
    width: 39.252,
    height: 53.477,
    rx: 5.47,
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7799",
    "data-name": "Group 7799",
    transform: "translate(313.243 134.29)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1574",
    "data-name": "Rectangle 1574",
    width: 39.252,
    height: 53.477,
    rx: 5.47,
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7800",
    "data-name": "Group 7800",
    transform: "translate(362.631 134.29)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1575",
    "data-name": "Rectangle 1575",
    width: 39.252,
    height: 53.477,
    rx: 5.47,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7801",
    "data-name": "Group 7801",
    transform: "translate(412.018 134.29)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1576",
    "data-name": "Rectangle 1576",
    width: 39.252,
    height: 53.477,
    rx: 5.47,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10883",
    "data-name": "Path 10883",
    d: "M299.466,177l4.7,2.509-2.107,3.538-4.742-2.81.075,5.219h-4.014V180.2l-4.742,2.848-2.07-3.538L291.262,177l-4.692-2.584,2.07-3.538,4.742,2.848V168.47h4.052l-.075,5.256,4.742-2.848,2.107,3.538Z",
    transform: "translate(-110.678 -15.752)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1577",
    "data-name": "Rectangle 1577",
    width: 123.539,
    height: 36.015,
    rx: 13.03,
    transform: "translate(246.405 220.596)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10884",
    "data-name": "Path 10884",
    d: "M364.5,237.325a5.595,5.595,0,0,1,9.684-3.462l-1.505,1.392a3.288,3.288,0,1,0,0,4.064l1.505,1.392a5.582,5.582,0,0,1-9.684-3.437Z",
    transform: "translate(-90.848 0.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10885",
    "data-name": "Path 10885",
    d: "M372.672,238.119a4.3,4.3,0,1,1,4.3,4.027,4.027,4.027,0,0,1-4.3-4.027Zm6.272,0a2.007,2.007,0,1,0-1.982,2.17,1.97,1.97,0,0,0,1.995-2.17Z",
    transform: "translate(-88.771 0.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10886",
    "data-name": "Path 10886",
    d: "M388.688,237.446v4.466H386.43v-4.14c0-1.254-.59-1.844-1.581-1.844a1.871,1.871,0,0,0-1.882,2.107v3.851H380.71v-7.8h2.158V235a3.45,3.45,0,0,1,2.584-1.029,3.061,3.061,0,0,1,3.236,3.475Z",
    transform: "translate(-86.723 0.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10887",
    "data-name": "Path 10887",
    d: "M393.929,241.855a3.186,3.186,0,0,1-1.844.5,2.572,2.572,0,0,1-2.91-2.81v-3.2H387.92V234.6h1.254V232.71h2.258V234.6h1.944v1.744h-1.944v3.174a.916.916,0,0,0,.978,1.029,1.555,1.555,0,0,0,.916-.289Z",
    transform: "translate(-84.889 0.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10888",
    "data-name": "Path 10888",
    d: "M393.51,232.466a1.406,1.406,0,0,1,2.81,0,1.418,1.418,0,0,1-2.81,0Zm.276,2.346h2.258v7.8h-2.258Z",
    transform: "translate(-83.466 0.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10889",
    "data-name": "Path 10889",
    d: "M405.188,237.438V241.9H402.93v-4.14c0-1.254-.59-1.844-1.581-1.844a1.871,1.871,0,0,0-1.882,2.107v3.851H397.21v-7.8h2.158v.916a3.45,3.45,0,0,1,2.6-.991,3.061,3.061,0,0,1,3.224,3.437Z",
    transform: "translate(-82.525 0.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10890",
    "data-name": "Path 10890",
    d: "M413.079,234.08v7.8h-2.145v-.928a3.149,3.149,0,0,1-2.421,1.054,3.111,3.111,0,0,1-3.337-3.512V234.08h2.3v4.077c0,1.254.577,1.894,1.581,1.894s1.806-.677,1.806-2.107V234.08Z",
    transform: "translate(-80.505 0.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10891",
    "data-name": "Path 10891",
    d: "M420.861,238.643h-5.909a2.07,2.07,0,0,0,2.233,1.568,2.672,2.672,0,0,0,1.957-.753l1.254,1.254a4.554,4.554,0,0,1-7.677-2.76A3.977,3.977,0,0,1,416.835,234a3.864,3.864,0,0,1,4.064,4.052C420.9,238.216,420.874,238.454,420.861,238.643Zm-5.934-1.254h3.839a1.857,1.857,0,0,0-1.919-1.631,1.831,1.831,0,0,0-1.919,1.568Z",
    transform: "translate(-78.578 0.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10892",
    "data-name": "Path 10892",
    d: "M396.729,58.225a5.532,5.532,0,1,1-1.616-3.92,5.545,5.545,0,0,1,1.616,3.92Z",
    transform: "translate(-85.469 -45.216)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10893",
    "data-name": "Path 10893",
    d: "M556.69,82.75V77.432a1.091,1.091,0,0,1,1.041-1.142h7.991a1.091,1.091,0,0,1,1.041,1.142V82.75a1.091,1.091,0,0,1-1.041,1.142h-7.991a1.091,1.091,0,0,1-1.041-1.142Z",
    transform: "translate(-41.944 -39.208)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10894",
    "data-name": "Path 10894",
    d: "M572.256,86.126H556.475a1.418,1.418,0,0,1-1.405-1.418V76.015a1.405,1.405,0,0,1,1.405-1.4H572.03a1.254,1.254,0,0,1,1.254,1.254V77.47a.2.2,0,0,0,.2.2h1.706a.84.84,0,0,1,.84.84v2.86a1.041,1.041,0,0,1-1.041,1.041h-1.254a.213.213,0,0,0-.213.213v2.22a1.254,1.254,0,0,1-1.267,1.28ZM556.475,75.237a.778.778,0,0,0-.778.778v8.693a.79.79,0,0,0,.778.79h15.781a.665.665,0,0,0,.652-.665V82.626a.84.84,0,0,1,.84-.84H575a.414.414,0,0,0,.414-.414V78.536a.226.226,0,0,0-.213-.213H573.5a.84.84,0,0,1-.828-.828V75.89a.652.652,0,0,0-.665-.652Z",
    transform: "translate(-42.356 -39.636)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-35",
    transform: "translate(56.595 225.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10895",
    "data-name": "Path 10895",
    d: "M185.06,205.025a10.525,10.525,0,0,0-9.534-7.175c1.1-3.1-1.016-6.674-4.027-7.978a11.7,11.7,0,0,0-9.509.69c-2.095.991-4.052,2.371-6.272,2.885-2.973.677-6.046-.263-9.082-.364a17,17,0,0,0-15.267,8.894c-1.016,1.919-1.643,4.039-2.76,5.909-.9,1.493-2.082,2.8-2.973,4.3a12.858,12.858,0,0,0,1.029,14.188l42.764-9.822a10.261,10.261,0,0,0,15.631-11.5Z",
    transform: "translate(-33.723 -189.174)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10896",
    "data-name": "Path 10896",
    d: "M260.047,328.16l-41.234-4.09-2.383,21.414L263,343.865Z",
    transform: "translate(-10.197 -154.849)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10897",
    "data-name": "Path 10897",
    d: "M282.8,342.055a2.321,2.321,0,0,1-2.383.928,2.761,2.761,0,0,1-.552-.213c-1.254-.615-.69-3.236-.69-3.236l-6.046-1.982s-8.882,3.914-12.294,6.912-10.287-.953-10.287-.953l-.452-13.623,13.046-8.518s-.8.514.289-1.254S268,319.6,268,319.6c.715-.866,3.111-.841,3.111-.841l9.822,2.735a6.925,6.925,0,0,1,4.516,3.952l3.174,7.364s1.48,5.181.941,6.272a2.02,2.02,0,0,1-2.509.953s-1,3.086-1.844,3.073a6.973,6.973,0,0,1-2.383-.991Z",
    transform: "translate(-1.63 -156.2)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10898",
    "data-name": "Path 10898",
    d: "M263.24,342.721a4.217,4.217,0,0,0,.677-.364l1.882-1.079a68.884,68.884,0,0,1,7.3-3.5h-.151l6.034,2.032-.176-.3a7.771,7.771,0,0,0-.125,1.543,2.873,2.873,0,0,0,.464,1.593,1.606,1.606,0,0,0,.765.514,2.234,2.234,0,0,0,.866.188,2.6,2.6,0,0,0,1.681-.615,2.669,2.669,0,0,0,.326-.326l.075-.088h0l-.389.075h0l.188.113a7.227,7.227,0,0,0,.753.414,5.859,5.859,0,0,0,.815.339,2.37,2.37,0,0,0,.452.125,1.053,1.053,0,0,0,.59,0,1.957,1.957,0,0,0,.74-.728,7.158,7.158,0,0,0,.439-.8,15.367,15.367,0,0,0,.677-1.694l-.4.188a2.383,2.383,0,0,0,2.434-.414,1.97,1.97,0,0,0,.627-1.179,5.793,5.793,0,0,0,0-1.254,33.872,33.872,0,0,0-1-4.729h0l-1.694-3.926-1.066-2.509a12.77,12.77,0,0,0-1.254-2.446,6.7,6.7,0,0,0-2.007-1.844,8.88,8.88,0,0,0-2.509-.928l-9.27-2.509H270.9a9.608,9.608,0,0,0-1.719.176,2.847,2.847,0,0,0-1.606.778h.364a3.475,3.475,0,0,0-3.237-.326,4.077,4.077,0,0,0-1.995,2.283l.1-.125-8.994,5.833-2.421,1.618a7.026,7.026,0,0,0-.828.6,5.257,5.257,0,0,0,.9-.489l2.509-1.505,9.095-5.645h0v-.075a3.613,3.613,0,0,1,1.744-1.982,2.986,2.986,0,0,1,2.735.314l.2.125.163-.176a2.383,2.383,0,0,1,1.254-.577,8.265,8.265,0,0,1,1.593-.15h0l9.245,2.609a8.291,8.291,0,0,1,2.321.866,6.072,6.072,0,0,1,1.806,1.681,11.446,11.446,0,0,1,1.154,2.321c.364.828.715,1.656,1.079,2.509l1.693,3.926h0a33.2,33.2,0,0,1,.991,4.629,5.381,5.381,0,0,1,0,1.091,1.342,1.342,0,0,1-.427.8,1.794,1.794,0,0,1-1.794.3l-.3-.1-.1.289a12.058,12.058,0,0,1-.64,1.618,3.073,3.073,0,0,1-.853,1.254,1.065,1.065,0,0,1-.263,0l-.364-.1c-.251-.088-.5-.2-.753-.314a7.871,7.871,0,0,1-.715-.389l-.176-.1h0l-.389.075h0v.075a2.514,2.514,0,0,1-.263.251,2.02,2.02,0,0,1-1.254.489,1.769,1.769,0,0,1-.677-.138.941.941,0,0,1-.527-.339,3.839,3.839,0,0,1-.276-2.685v-.238l-.213-.063-6.047-1.957h-.151a60.308,60.308,0,0,0-7.251,3.688c-.815.489-1.43.891-1.844,1.179a4.108,4.108,0,0,0-.539.2Z",
    transform: "translate(-1.51 -156.238)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10899",
    "data-name": "Path 10899",
    d: "M265.28,322.43a12.622,12.622,0,0,0,3.061,1.455,32.165,32.165,0,0,0,8.166,1.907l-.3-.276c.1.527.188,1.066.326,1.618a24.938,24.938,0,0,0,3.839,8.681,20.7,20.7,0,0,0,1.807,2.233c.464.5.753.74.79.715s-.928-1.192-2.208-3.211a27.7,27.7,0,0,1-3.575-8.568c-.125-.527-.226-1.066-.314-1.568v-.263h-.251a38.886,38.886,0,0,1-8.079-1.668,29.676,29.676,0,0,0-3.262-1.054Z",
    transform: "translate(2.233 -155.266)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10900",
    "data-name": "Path 10900",
    d: "M272.12,328.27a16.308,16.308,0,0,0,5.319,10.977c.163-.138-1.668-2.22-3.124-5.256S272.321,328.232,272.12,328.27Z",
    transform: "translate(3.973 -153.78)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10901",
    "data-name": "Path 10901",
    d: "M249.39,337.545a1.671,1.671,0,0,0,.289.238,8.923,8.923,0,0,0,.928.539,11.078,11.078,0,0,0,3.876,1.079,10.952,10.952,0,0,0,6-1.167,11.466,11.466,0,0,0,5.281-5.62l-.4.188a25.842,25.842,0,0,0,7.188,1.48,24.892,24.892,0,0,0,2.735,0,8.305,8.305,0,0,0,2.685-.439,2.07,2.07,0,0,0,1.142-.941,1.919,1.919,0,0,0,.063-1.468,1.894,1.894,0,0,0-.991-1.054l-1.1-.477c-2.923-1.254-5.62-2.17-7.891-2.91s-4.152-1.254-5.444-1.581A9.935,9.935,0,0,0,261.7,325a17.191,17.191,0,0,0,1.97.665c1.254.4,3.111.991,5.369,1.781s4.9,1.794,7.8,3.036l1.091.477a1.305,1.305,0,0,1,.64,1.656,1.43,1.43,0,0,1-.815.627,7.713,7.713,0,0,1-2.509.376h-2.672a25.677,25.677,0,0,1-7.012-1.43l-.289-.1-.113.276a11.065,11.065,0,0,1-5.018,5.394,10.914,10.914,0,0,1-5.708,1.254,11.79,11.79,0,0,1-3.763-.878A13.108,13.108,0,0,1,249.39,337.545Z",
    transform: "translate(-1.81 -154.612)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10902",
    "data-name": "Path 10902",
    d: "M148.456,307.833a18.7,18.7,0,0,1-18.29-18.729L129.388,227c-.728-16.672,8.1-31.01,24.324-31.286h1.505c15.116.64,27.209,13.1,27.8,28.639.552,14.464,1.142,28.426.74,36.153-.84,16.007-16.659,17.562-16.659,17.562v10.663a18.7,18.7,0,0,1-18.6,19.018Z",
    transform: "translate(-32.356 -187.511)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10903",
    "data-name": "Path 10903",
    d: "M163.5,262.935a36.831,36.831,0,0,1-20.009-7.025s4.391,12.243,19.971,11.453Z",
    transform: "translate(-28.757 -172.192)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10904",
    "data-name": "Path 10904",
    d: "M168.466,230.363a2.283,2.283,0,0,1-2.233,2.22A2.158,2.158,0,0,1,164,230.451a2.246,2.246,0,0,1,2.233-2.22,2.17,2.17,0,0,1,2.233,2.133Z",
    transform: "translate(-23.538 -179.236)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10905",
    "data-name": "Path 10905",
    d: "M171.06,224.646c-.289.289-1.919-1.066-4.315-1.154s-4.19,1.054-4.441.74.188-.665.966-1.254a6.034,6.034,0,0,1,3.575-.966,5.708,5.708,0,0,1,3.412,1.254C170.973,223.968,171.2,224.508,171.06,224.646Z",
    transform: "translate(-23.988 -180.82)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10906",
    "data-name": "Path 10906",
    d: "M151.151,230.368a2.258,2.258,0,0,1-2.233,2.22,2.17,2.17,0,0,1-2.208-2.158,2.258,2.258,0,0,1,2.233-2.22,2.158,2.158,0,0,1,2.208,2.158Z",
    transform: "translate(-27.938 -179.241)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10907",
    "data-name": "Path 10907",
    d: "M152.361,224.306c-.289.289-1.932-1.066-4.315-1.154s-4.19,1.054-4.441.74.176-.665.966-1.254a6.034,6.034,0,0,1,3.575-.966,5.771,5.771,0,0,1,3.412,1.254C152.26,223.628,152.5,224.18,152.361,224.306Z",
    transform: "translate(-28.746 -180.906)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10908",
    "data-name": "Path 10908",
    d: "M156.86,243.3a15.568,15.568,0,0,1,3.914-.552c.615,0,1.254-.138,1.317-.565a3.312,3.312,0,0,0-.339-1.882c-.514-1.543-1.054-3.161-1.606-4.855-2.245-6.925-3.763-12.545-3.563-12.683s2.308,5.432,4.541,12.356c.539,1.706,1.054,3.324,1.53,4.88a3.676,3.676,0,0,1,.226,2.509,1.543,1.543,0,0,1-1.041.866,4.1,4.1,0,0,1-1.041.113,15.543,15.543,0,0,1-3.939-.188Z",
    transform: "translate(-25.43 -180.628)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10909",
    "data-name": "Path 10909",
    d: "M153.649,218.236c-.351.615-2.647-.151-5.469-.326s-5.193.163-5.457-.5c-.113-.314.389-.853,1.4-1.254a8.881,8.881,0,0,1,4.228-.677,8.982,8.982,0,0,1,4.09,1.254C153.386,217.32,153.8,217.935,153.649,218.236Z",
    transform: "translate(-28.956 -182.489)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10910",
    "data-name": "Path 10910",
    d: "M171.541,218.894c-.514.552-2.509-.088-4.792-.176s-4.328.263-4.767-.339c-.2-.289.125-.84,1-1.342a7.8,7.8,0,0,1,7.715.414C171.5,218.041,171.766,218.631,171.541,218.894Z",
    transform: "translate(-24.066 -182.294)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10911",
    "data-name": "Path 10911",
    d: "M132.163,230.273c-.263-.125-10.563-3.7-10.663,7.251s10.613,8.781,10.638,8.493S132.163,230.273,132.163,230.273Z",
    transform: "translate(-34.353 -178.883)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10912",
    "data-name": "Path 10912",
    d: "M128.387,241.117a2.9,2.9,0,0,1-.5.276,1.806,1.806,0,0,1-1.392,0c-1.116-.439-2.057-2.283-2.082-4.265a6.272,6.272,0,0,1,.539-2.722,2.183,2.183,0,0,1,1.4-1.455.928.928,0,0,1,1.091.539c.151.3.075.527.138.539s.226-.176.138-.627a1.129,1.129,0,0,0-.414-.69,1.254,1.254,0,0,0-1.016-.288,2.622,2.622,0,0,0-1.957,1.668,6.648,6.648,0,0,0-.665,3.048c0,2.208,1.129,4.29,2.659,4.767a1.957,1.957,0,0,0,1.694-.276C128.362,241.38,128.425,241.142,128.387,241.117Z",
    transform: "translate(-33.801 -178.173)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10913",
    "data-name": "Path 10913",
    d: "M138.7,211.952a7.8,7.8,0,0,1,5.319-6.072,10.876,10.876,0,0,1,7.188.088c6.009,2.183,16.308,5.457,18.93,3.362,3.839-3.011,4.767-5.018,4.767-5.018l2.12,2.308c1.719-.978-3.45-6.724-7.69-8.706-6.4-2.986-16.17-4.83-22.078-3.111-7.113,2.07-13.021,5.7-16.6,12.356a44.069,44.069,0,0,0-4.7,21.991c0,2.321-.364,8.969,1.869,9.484,1.744.389,3.964,1.167,3.839,4.5a4.642,4.642,0,0,0,1.1,3.349c1.944,2.133,4.328.125,5.432-1.882,2.346-4.29,2.609-9.408,2.81-14.326a32.956,32.956,0,0,0-.665-10.425,32.763,32.763,0,0,1-1.719-6.724,5.669,5.669,0,0,1,.075-1.179Z",
    transform: "translate(-33.233 -187.909)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10914",
    "data-name": "Path 10914",
    d: "M158.784,244.728c.063.163-.426.577-1.418.79a5.658,5.658,0,0,1-3.851-.6,5.846,5.846,0,0,1-2.609-2.9c-.376-.941-.314-1.568-.138-1.618s1.167,2.082,3.412,3.3S158.684,244.364,158.784,244.728Z",
    transform: "translate(-26.941 -176.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10915",
    "data-name": "Path 10915",
    d: "M195,379.086l-50.956-11.215L111.291,286.72s-43.768,9.709-50.981,34.222C54.037,342.079,41.166,435.511,70.471,493.1a44.27,44.27,0,0,0,39.515,24.01h223a55.285,55.285,0,0,0,54.946-49.13c1.254-11.285,2.132-21.985,1.956-28.96l-35.8-27.473Z",
    transform: "translate(-52.03 -164.352)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7802",
    "data-name": "Group 7802",
    transform: "translate(279.205 236.071)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10916",
    "data-name": "Path 10916",
    d: "M274.6,384.247c15.693,20.5,34.786,38.888,57.617,50.956l1.091-27.824L291.134,377.36Z",
    transform: "translate(-274.6 -377.36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10917",
    "data-name": "Path 10917",
    d: "M140.947,275.211c0,1.48,11.591,6.272,16.822,4.165,7.978-3.186,6.987-9.446,6.987-9.446l4.428,4.667,44.37,67.615,32.98,21.765L193.747,380.7,138.4,317.123Z",
    transform: "translate(-30.052 -168.625)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10918",
    "data-name": "Path 10918",
    d: "M135.031,256.05l-1.167,2.183-5.269,9.822L106.68,282.03l45.073,53.578,20.561,48.623,49.3,15.43s-23.458-36.066-30.747-54.506-8.029-17.562-14.677-31.085a303.356,303.356,0,0,1-12.043-29.229Z",
    transform: "translate(-38.124 -172.157)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10919",
    "data-name": "Path 10919",
    d: "M227.206,350.155l9.672,9.02,2.735,5.57L203.66,348.023,177.7,311.644s-9.245-20.51-12.419-27.861c-3.349-7.727-5.846-12.105-5.846-12.105v-6.1L172.524,277.4l10.926,3.249L201.715,309.5Z",
    transform: "translate(-24.699 -169.732)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10920",
    "data-name": "Path 10920",
    d: "M211.706,313.211s-4.366-9.308-7.928-17.048c-8.029-17.437-26.958-19.093-26.958-19.093L197.744,335.1l25.629,18.177s7.3,2.509,8.217,0c0,0,5.331-19.243,5.168-19.319s-18.24-5.482-18.24-5.482l-7.276-16.308",
    transform: "translate(-20.276 -166.808)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10921",
    "data-name": "Path 10921",
    d: "M240.411,291.659l-24.9,41.485,26.08-.765,22.994-38.437a2.22,2.22,0,0,0-1.907-3.362h-20.36A2.22,2.22,0,0,0,240.411,291.659Z",
    transform: "translate(-10.431 -163.37)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10922",
    "data-name": "Path 10922",
    d: "M159,335.083l62.334-7.414,10.475-18.353,8.2-4.5a4.077,4.077,0,0,1,4.378.276l.778.564,6.084-.765a4.792,4.792,0,0,1,3,.59l4.315,2.509a2.082,2.082,0,0,1,1.029,1.781h0a2.07,2.07,0,0,1-2.446,2.032l-4.19-.765-6.423,2.095s4.14.439,4.667,3.575-1.568,3.211-1.568,3.211,4.353,2.509,1.254,6.272c0,0,3.638,2.421-.439,7.012-2.747,3.111-22.58,13.247-22.58,13.247L159,371.952Z",
    transform: "translate(-24.811 -159.878)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10923",
    "data-name": "Path 10923",
    d: "M235.883,321.73a1.59,1.59,0,0,1,1.016.565,3.287,3.287,0,0,1,.665,3.073,9.12,9.12,0,0,1-2.685,3.839,33.422,33.422,0,0,1-4.378,3.613,59.07,59.07,0,0,1-8.994,4.955,22.834,22.834,0,0,1-3.926,1.593,31.734,31.734,0,0,1,3.763-2.007,74.331,74.331,0,0,0,8.781-5.081,35.434,35.434,0,0,0,4.34-3.512,8.893,8.893,0,0,0,2.647-3.525,3.086,3.086,0,0,0-.4-2.785A3.979,3.979,0,0,0,235.883,321.73Z",
    transform: "translate(-9.905 -155.444)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10924",
    "data-name": "Path 10924",
    d: "M228.808,305.511a17.023,17.023,0,0,1-6.4,1.731,8.569,8.569,0,0,1,3.111-1.179,8.781,8.781,0,0,1,3.287-.552Z",
    transform: "translate(-8.676 -159.572)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10925",
    "data-name": "Path 10925",
    d: "M235.709,309.63a17.559,17.559,0,0,1-4.328,1.781,17.312,17.312,0,0,1-4.541,1.167,16.534,16.534,0,0,1,4.328-1.781,16.735,16.735,0,0,1,4.541-1.167Z",
    transform: "translate(-7.548 -158.523)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10926",
    "data-name": "Path 10926",
    d: "M228.173,316.761c-.188,0-.276-.565-.489-1.179s-.464-1.091-.326-1.254.69.251.941,1.016S228.286,316.786,228.173,316.761Z",
    transform: "translate(-7.427 -157.337)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10927",
    "data-name": "Path 10927",
    d: "M229.849,322.789c-.188,0-.113-.941-.376-1.957s-.715-1.794-.577-1.919.916.552,1.254,1.756A2.108,2.108,0,0,1,229.849,322.789Z",
    transform: "translate(-7.032 -156.165)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10928",
    "data-name": "Path 10928",
    d: "M111.608,275.87c-2.082,1.254-19.708,13.3-17.136,33.017s41.585,64.3,49.727,65.156l31.3,5.143V342.319l-15.053-.853-19.67-38.587Z",
    transform: "translate(-41.295 -167.113)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10929",
    "data-name": "Path 10929",
    d: "M167.219,334.247a6.1,6.1,0,0,1-1.116.1l-3.161.125-11.215.251h-.151l-.1-.125-7.928-10.663c-4.729-6.385-8.969-12.193-12.018-16.421l-3.575-5.018a13.9,13.9,0,0,1-1.254-1.907,14.541,14.541,0,0,1,1.455,1.744l3.763,4.892c3.149,4.14,7.527,9.91,12.181,16.308l7.865,10.7-.251-.125H166.09a4.615,4.615,0,0,1,1.129.138Z",
    transform: "translate(-33.03 -160.823)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10930",
    "data-name": "Path 10930",
    d: "M160.337,287.128a7.529,7.529,0,0,1-.615-1.116l-1.543-3.236h.339a39.5,39.5,0,0,0-3.023,5.206,45.773,45.773,0,0,1-3.926,6.9l-.251.351-.263-.339c-2.032-2.509-4.353-5.156-6.849-7.878-5.457-5.934-10.675-11.077-14.4-14.84l-4.4-4.478a13.8,13.8,0,0,1-1.53-1.706,15.05,15.05,0,0,1,1.731,1.518l4.554,4.315c3.763,3.676,9.095,8.781,14.577,14.715,2.509,2.735,4.817,5.419,6.837,7.941h-.527a49.812,49.812,0,0,0,3.964-6.774,34.984,34.984,0,0,1,3.2-5.181l.2-.276.125.3c.564,1.355,1.029,2.446,1.38,3.312a5.232,5.232,0,0,1,.426,1.267Z",
    transform: "translate(-33.75 -169.627)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10931",
    "data-name": "Path 10931",
    d: "M171.4,275.745a6.058,6.058,0,0,1,.941,1.857,49.242,49.242,0,0,1,1.643,5.181l.426,1.53-.978-1.254a42.3,42.3,0,0,0-4.591-4.855c-1.455-1.33-2.873-2.509-4.165-3.688l.527-.2a53.7,53.7,0,0,0-.188,6.184,6.573,6.573,0,0,1-.314,2.421c-.075,0,0-.891-.088-2.409a40.259,40.259,0,0,1,0-6.272l.063-.59.464.389c1.254,1.091,2.76,2.308,4.228,3.663a36.919,36.919,0,0,1,4.616,5.018l-.552.263c-.539-2.17-.978-3.977-1.38-5.219a14.87,14.87,0,0,1-.652-2.02Z",
    transform: "translate(-23.413 -167.678)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10932",
    "data-name": "Path 10932",
    d: "M211.329,332.072a12.357,12.357,0,0,1-1.493-1.38l-3.851-3.939c-1.618-1.694-3.538-3.588-5.645-5.934-.966-1.254-1.819-2.6-2.823-3.914a26.344,26.344,0,0,1-2.609-4.541c-1.493-3.236-2.622-6.435-3.638-9.333s-1.907-5.52-2.722-7.677a52.531,52.531,0,0,0-2.145-5.018,15.544,15.544,0,0,1-.9-1.806,2.452,2.452,0,0,1,.326.4,12.087,12.087,0,0,1,.815,1.254,42.124,42.124,0,0,1,2.371,5.018c.891,2.158,1.832,4.754,2.873,7.64s2.183,6.059,3.663,9.258a26.944,26.944,0,0,0,2.509,4.428c1.016,1.342,1.869,2.735,2.785,3.926,1.97,2.245,3.939,4.278,5.482,5.984l3.7,4.077A11.957,11.957,0,0,1,211.329,332.072Z",
    transform: "translate(-18.068 -163.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10933",
    "data-name": "Path 10933",
    d: "M227.256,340.505l118.32-3.324a13.335,13.335,0,0,1,5.469,1.016c4.3,1.832,12.043,6.536,17.349,17.8,7.69,16.308,43.567,85.3,43.567,85.3l-36.279,18.591-44.5-82.543L194,365.682l1.593-10.964Z",
    transform: "translate(-15.905 -151.514)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10934",
    "data-name": "Path 10934",
    d: "M330.24,426.4l18.9,32.453,1.254,8.2a9.183,9.183,0,0,0,10.475,7.69l57.542-8.781a4.478,4.478,0,0,0,3.55-6.147,3.889,3.889,0,0,0-2.735-2.233c-4.817-1.254-41.949-14.865-41.949-14.865L361.8,411.66Z",
    transform: "translate(18.762 -132.561)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10935",
    "data-name": "Path 10935",
    d: "M344.5,431.6a35.49,35.49,0,0,1-4.253-5.219,33.959,33.959,0,0,1-3.763-5.607,35.92,35.92,0,0,1,4.24,5.219A34.575,34.575,0,0,1,344.5,431.6Z",
    transform: "translate(20.35 -130.243)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10936",
    "data-name": "Path 10936",
    d: "M353.244,428.137a22.817,22.817,0,0,1-3.964-5.469,23.482,23.482,0,0,1-2.81-6.147c.176-.088,1.505,2.622,3.375,5.821S353.407,428.024,353.244,428.137Z",
    transform: "translate(22.892 -131.324)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10937",
    "data-name": "Path 10937",
    d: "M361.3,463.624c-.125,0-.427-1.117-1.254-2.81a16.747,16.747,0,0,0-11.2-8.781c-1.844-.439-3.036-.452-3.036-.577a7.088,7.088,0,0,1,3.149,0,15.38,15.38,0,0,1,11.579,9.095A7.375,7.375,0,0,1,361.3,463.624Z",
    transform: "translate(22.724 -122.479)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10938",
    "data-name": "Path 10938",
    d: "M389.313,459.528a4.816,4.816,0,0,1-.916-2.145,10.036,10.036,0,0,1,.276-5.658,13.572,13.572,0,0,1,3-4.779,5.947,5.947,0,0,1,1.781-1.505c.075.088-.514.753-1.38,1.857a17.373,17.373,0,0,0-2.685,4.679,11.189,11.189,0,0,0-.464,5.294A14.92,14.92,0,0,1,389.313,459.528Z",
    transform: "translate(33.489 -123.965)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10939",
    "data-name": "Path 10939",
    d: "M197.416,355.087s122.1-12.243,128.03-11.754c10.951.9,31.148,18.177,66.988,42.238a330.161,330.161,0,0,1,51.433,43.216l-11.453,26.143s-80.285-29.266-92.893-39.791c-10.462-8.781-29.555-21.2-29.555-21.2l-47.092.477L227.862,397.5a51.433,51.433,0,0,1-45.386-19.983L168.89,359.766Z",
    transform: "translate(-22.294 -149.951)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10940",
    "data-name": "Path 10940",
    d: "M295.5,393.762s.2.113.565.364l1.643,1.129,6.335,4.453c5.507,3.926,13.586,9.571,23.5,17.061.627.464,1.254,1,1.882,1.418l2.02,1.254c1.455.728,2.91,1.53,4.453,2.245l4.717,2.2,5.018,2.2q10.174,4.4,21.94,9.183c15.656,6.36,33.218,13.272,52.173,20.561l-.414.188L429.7,429.664l.075.376-14.251-14.527h0c-3.349-2.9-6.937-5.984-10.6-9.032A749.514,749.514,0,0,0,336.479,356.3h0a66.737,66.737,0,0,0-10.362-7.288A51.672,51.672,0,0,0,315.04,344.2c-.953-.251-1.907-.452-2.848-.69l-2.848-.439-2.848-.151H292.7l-36.868-.075-23.935-.1h-7.9a4.664,4.664,0,0,1-.552,0H231.9l23.935-.088,36.868-.075h13.8l2.9.138,2.91.439c.953.238,1.919.439,2.885.7a51.431,51.431,0,0,1,11.215,4.842,66.245,66.245,0,0,1,10.487,7.351h0a739.072,739.072,0,0,1,68.544,50.178c3.675,3.048,7.263,6.134,10.613,9.045h0L430.3,429.815l.151.163-.075.213-10.412,26.344-.113.3-.3-.113c-18.955-7.313-36.517-14.263-52.16-20.661-7.815-3.2-15.141-6.272-21.915-9.245l-5.018-2.22-4.767-2.459c-1.53-.74-3-1.543-4.453-2.283l-2.07-1.254c-.677-.414-1.254-.953-1.882-1.418-9.86-7.527-17.914-13.234-23.371-17.224l-6.272-4.529-1.606-1.179C295.647,393.912,295.5,393.762,295.5,393.762Z",
    transform: "translate(-8.413 -150.139)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10941",
    "data-name": "Path 10941",
    d: "M358.26,434.379l33.87,13.31,5.633,6.1a9.2,9.2,0,0,0,13,.5l42.727-39.54a4.491,4.491,0,0,0-.5-7.088,3.914,3.914,0,0,0-3.513-.314c-4.679,1.681-43.078,11.177-43.078,11.177L380.64,398Z",
    transform: "translate(25.892 -136.037)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10942",
    "data-name": "Path 10942",
    d: "M358.26,434.453s.113-.213.364-.64l1.142-1.882c1.016-1.693,2.509-4.14,4.4-7.276,3.864-6.36,9.433-15.493,16.308-26.707l.138-.238.226.176,25.754,20.473h-.263l22.906-5.771,12.105-3.149c2.045-.552,4.115-1.091,6.172-1.694l1.53-.477a6.275,6.275,0,0,1,1.656-.389,4.265,4.265,0,0,1,3.2,1.254,4.817,4.817,0,0,1,.464,6.272,8.783,8.783,0,0,1-1.154,1.254l-1.167,1.079-2.321,2.145-9.107,8.417-17.224,15.906-8.016,7.4-3.839,3.55a13.387,13.387,0,0,1-2.032,1.618,9.446,9.446,0,0,1-11.5-1.255c-2.158-2.245-4.115-4.441-6.034-6.511h.088c-10.45-4.165-18.9-7.527-24.788-9.885l-6.674-2.7-1.731-.7-.565-.238s.226.063.64.226l1.769.665,6.774,2.609,24.738,9.6h0c1.932,2.057,3.926,4.265,6.034,6.46a8.944,8.944,0,0,0,8.656,2.12,8.779,8.779,0,0,0,2.22-.991,12.438,12.438,0,0,0,1.932-1.568c1.254-1.167,2.509-2.358,3.839-3.55q3.889-3.613,8-7.426c5.469-5.018,11.227-10.412,17.2-15.932q4.466-4.152,9.095-8.43l2.321-2.145a26.333,26.333,0,0,0,2.233-2.183,4.19,4.19,0,0,0-.376-5.444,3.588,3.588,0,0,0-2.722-1.029,5.433,5.433,0,0,0-1.48.364l-1.568.477c-2.07.6-4.127,1.142-6.184,1.694L429.3,413.14l-22.906,5.733h-.151l-.113-.088-25.616-20.523h.364l-16.421,26.419-4.554,7.263-1.254,1.894C358.423,434.215,358.26,434.453,358.26,434.453Z",
    transform: "translate(25.892 -136.11)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10943",
    "data-name": "Path 10943",
    d: "M406.5,441.126c-.088.088-.978-.69-2.647-1.606a16.722,16.722,0,0,0-14.2-1.016c-1.769.665-2.772,1.317-2.848,1.254a7.428,7.428,0,0,1,2.647-1.719,15.38,15.38,0,0,1,14.677,1.054,7.012,7.012,0,0,1,2.371,2.032Z",
    transform: "translate(33.157 -126.2)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10944",
    "data-name": "Path 10944",
    d: "M426.7,422.065a5.143,5.143,0,0,1-1.969-1.254,10.036,10.036,0,0,1-2.923-4.842,13.711,13.711,0,0,1-.2-5.645,5.681,5.681,0,0,1,.64-2.233,9.2,9.2,0,0,1-.1,2.3,16.71,16.71,0,0,0,.389,5.382,11.165,11.165,0,0,0,2.584,4.654C426.064,421.425,426.779,421.952,426.7,422.065Z",
    transform: "translate(41.961 -133.469)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10945",
    "data-name": "Path 10945",
    d: "M314.3,396.482c-2.622-12.432-7.978-25.152-18.578-32.139-8.041-5.319-17.989-6.624-27.6-7.8L68.093,331.94C66.3,363.464,79.8,402.7,93.571,431.13c2.133,4.416,4.6,8.932,8.693,11.629,5.018,3.287,11.39,3.249,17.362,3.1,67.3-1.719,134.628-4.579,201.553-11.942C317.416,421.784,316.914,408.9,314.3,396.482Z",
    transform: "translate(-47.984 -152.846)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10946",
    "data-name": "Path 10946",
    d: "M138.766,340.883a15.552,15.552,0,0,1-2.358-.151l-6.4-.69c-5.394-.627-12.833-1.543-21.037-2.672S93.342,335.1,88,334.159c-2.685-.477-4.842-.866-6.272-1.254a15.614,15.614,0,0,1-2.3-.565,15.638,15.638,0,0,1,2.346.289l6.348.978c5.369.8,12.783,1.869,20.987,3l21.012,2.873,6.373.916a14.8,14.8,0,0,1,2.271.489Z",
    transform: "translate(-45.058 -152.744)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10947",
    "data-name": "Path 10947",
    d: "M131.966,503.71a2.371,2.371,0,0,1-.2-.389c-.151-.289-.326-.677-.552-1.154l-2.032-4.478-1.468-3.174c-.5-1.254-.991-2.509-1.556-3.939-1.079-2.823-2.434-6.009-3.588-9.659-.6-1.806-1.254-3.7-1.894-5.683s-1.254-4.09-1.819-6.272c-1.254-4.3-2.333-8.994-3.487-13.912a227.708,227.708,0,0,1-4.529-65.382c.464-5.018.828-9.81,1.53-14.251.339-2.22.564-4.378.941-6.435s.753-4.014,1.1-5.9c.64-3.763,1.543-7.113,2.22-10.036.364-1.48.665-2.848,1-4.1s.7-2.383,1-3.412c.59-2.02,1.066-3.6,1.392-4.717l.389-1.254a2.107,2.107,0,0,1,.151-.414,1.58,1.58,0,0,1-.088.426l-.314,1.255-1.254,4.742L117.979,349c-.314,1.254-.6,2.647-.941,4.115-.652,2.96-1.518,6.272-2.12,10.036-.326,1.869-.69,3.839-1.054,5.883s-.577,4.2-.891,6.423c-.69,4.428-1.029,9.208-1.48,14.226a234.408,234.408,0,0,0,4.516,65.232c1.142,4.9,2.133,9.6,3.425,13.887.615,2.158,1.129,4.253,1.769,6.272s1.254,3.876,1.857,5.683c1.116,3.65,2.434,6.837,3.475,9.684.552,1.418,1.016,2.747,1.505,3.952l1.4,3.249,1.907,4.529.489,1.192a1.794,1.794,0,0,1,.125.351Z",
    transform: "translate(-37.229 -151.011)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10948",
    "data-name": "Path 10948",
    d: "M129.048,419.84a43.411,43.411,0,0,1-7.865,0,43.906,43.906,0,0,1-7.853-.715,45.063,45.063,0,0,1,7.878,0A44.861,44.861,0,0,1,129.048,419.84Z",
    transform: "translate(-36.432 -130.705)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10949",
    "data-name": "Path 10949",
    d: "M127.525,428.264a24.789,24.789,0,0,1-8.079-2.12,24.523,24.523,0,0,1-7.276-4.1c.113-.176,3.3,1.744,7.527,3.45S127.562,427.988,127.525,428.264Z",
    transform: "translate(-36.727 -129.922)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10950",
    "data-name": "Path 10950",
    d: "M112.6,376.886a10.437,10.437,0,0,1-5.206,1.593,10.65,10.65,0,0,1-5.419-.565c0-.213,2.421.151,5.357-.138S112.52,376.7,112.6,376.886Z",
    transform: "translate(-39.322 -141.417)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10951",
    "data-name": "Path 10951",
    d: "M115.711,375.363a8.894,8.894,0,0,1-5.745-.728,8.781,8.781,0,0,1-4.516-3.625,29.557,29.557,0,0,0,4.792,2.973C113.1,375.225,115.711,375.137,115.711,375.363Z",
    transform: "translate(-38.437 -142.904)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10952",
    "data-name": "Path 10952",
    d: "M177.935,204.328a8.706,8.706,0,0,0-5.984-5.319,14.941,14.941,0,0,0-8.229.3l-25.992,5.946c3.763,2.509,11.5,4.867,15.944,5.344,6.486.69,11.052.753,14.915-1.48a4.867,4.867,0,0,0,6.837,2.509,6.272,6.272,0,0,0,2.509-7.3Z",
    transform: "translate(-30.223 -186.783)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10953",
    "data-name": "Path 10953",
    d: "M379.844,421.673A51.846,51.846,0,0,1,364.79,416c.075-.176,3.387,1.254,7.527,2.81S379.894,421.5,379.844,421.673Z",
    transform: "translate(27.554 -131.459)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10954",
    "data-name": "Path 10954",
    d: "M384.042,412.955a72.485,72.485,0,0,1-6.661-3.149,68.671,68.671,0,0,1-6.611-3.236,30.229,30.229,0,0,1,6.9,2.647,29.054,29.054,0,0,1,6.373,3.738Z",
    transform: "translate(29.076 -133.856)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10955",
    "data-name": "Path 10955",
    d: "M216.9,364.695l52.4.64,63.275-12.545a5.018,5.018,0,0,0,3.926-4.115L345.1,291.7a4.2,4.2,0,0,0-4.83-4.767L275.6,297.456a4.215,4.215,0,0,0-3.5,3.625l-7.213,57.943-47.92-.238a2.96,2.96,0,0,0-2.961,2.948h0a2.948,2.948,0,0,0,2.885,2.96Z",
    transform: "translate(-10.813 -164.313)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10956",
    "data-name": "Path 10956",
    d: "M216.908,364.742a2.146,2.146,0,0,1-.991-.163,2.961,2.961,0,0,1-1.894-2.17,3.036,3.036,0,0,1,2.509-3.625c1.919-.075,4.09,0,6.573,0l41.786.1-.226.2c2.057-16.672,4.5-36.379,7.2-58.307a4.541,4.541,0,0,1,2.772-3.274,10.187,10.187,0,0,1,2.107-.439l2.082-.351,8.443-1.367,17.4-2.848,18.027-2.91,9.208-1.493,4.654-.765,2.333-.376a11.586,11.586,0,0,1,2.434-.263,4.566,4.566,0,0,1,3.952,3.149,5.382,5.382,0,0,1,.075,2.6l-.376,2.434q-.728,4.867-1.455,9.672c-.966,6.385-1.919,12.7-2.86,18.88s-1.857,12.243-2.747,18.19l-.677,4.416c-.113.74-.213,1.468-.326,2.2a6.535,6.535,0,0,1-.615,2.22,5.256,5.256,0,0,1-3.55,2.747l-4.24.841-59.148,11.641h0l-38.411-.565-10.374-.188-2.8-.063h2.7l10.387.063,38.411.364h0l59.123-11.792,4.228-.853a4.617,4.617,0,0,0,3.136-2.421,5.657,5.657,0,0,0,.539-2.032l.339-2.2c.213-1.468.439-2.948.665-4.428l2.735-18.19q1.392-9.27,2.848-18.817.715-4.792,1.455-9.672l.364-2.434a4.579,4.579,0,0,0,0-2.3,3.889,3.889,0,0,0-3.374-2.7,11.292,11.292,0,0,0-2.271.251l-2.346.389-4.642.753-9.22,1.493-18.014,2.935-17.4,2.823-8.443,1.367-2.082.339a9.514,9.514,0,0,0-1.995.414,3.864,3.864,0,0,0-2.383,2.822c-2.76,21.853-5.244,41.585-7.339,58.244v.2h-.213l-41.786-.3c-2.509,0-4.679-.075-6.548,0a2.879,2.879,0,0,0-.64,5.532A3.833,3.833,0,0,0,216.908,364.742Z",
    transform: "translate(-10.826 -164.36)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10957",
    "data-name": "Path 10957",
    d: "M266.488,296.77c.176,0-1.556,15.141-3.876,33.783s-4.34,33.732-4.529,33.707,1.568-15.141,3.889-33.783S266.312,296.745,266.488,296.77Z",
    transform: "translate(0.398 -161.795)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10958",
    "data-name": "Path 10958",
    d: "M287.333,316.211c-1.317,2.747-.59,5.833,1.618,6.9s5.018-.314,6.385-3.061.59-5.833-1.618-6.887S288.65,313.464,287.333,316.211Z",
    transform: "translate(7.678 -157.715)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-35",
    transform: "translate(659.805 324.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10959",
    "data-name": "Path 10959",
    d: "M679.37,296.65a1.906,1.906,0,0,1-.125.477l-.452,1.367c-.4,1.192-.979,2.948-1.794,5.206-1.581,4.516-3.964,11.027-7.113,18.992a435.155,435.155,0,0,1-29.041,60.214,134.376,134.376,0,0,0-8.292,17.048,77.2,77.2,0,0,0-4.441,17.086,122.1,122.1,0,0,0,0,29.919c.916,8.505,2.145,15.329,2.935,20.071.4,2.321.715,4.152.941,5.432.1.59.176,1.054.226,1.405a2.927,2.927,0,0,1,.063.489,3.243,3.243,0,0,1-.125-.477c-.075-.339-.176-.8-.288-1.4-.251-1.254-.615-3.086-1.066-5.407-.866-4.7-2.17-11.516-3.149-20.071a120.793,120.793,0,0,1-.075-30.107A76.9,76.9,0,0,1,632,399.666a133.258,133.258,0,0,1,8.33-17.186A453.063,453.063,0,0,0,669.5,322.4c3.211-7.928,5.658-14.414,7.313-18.9.828-2.22,1.468-3.952,1.907-5.168l.514-1.342A2.872,2.872,0,0,1,679.37,296.65Z",
    transform: "translate(-509.019 -260.409)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10960",
    "data-name": "Path 10960",
    d: "M666.929,356.62a5.132,5.132,0,0,1-.4.728l-1.254,2.02c-1.1,1.756-2.747,4.265-4.779,7.351-4.064,6.184-9.86,14.6-15.693,24.261-2.885,4.842-5.457,9.559-7.615,13.937s-3.889,8.43-5.256,11.855-2.371,6.272-3,8.217c-.326.928-.577,1.681-.778,2.258a3.523,3.523,0,0,1-.314.765,3.344,3.344,0,0,1,.188-.8c.163-.59.389-1.355.652-2.3.565-1.995,1.53-4.83,2.81-8.3s3-7.527,5.143-11.955,4.7-9.158,7.615-14.012c5.833-9.684,11.7-18.064,15.856-24.186l4.955-7.226,1.367-1.957A4.065,4.065,0,0,1,666.929,356.62Z",
    transform: "translate(-508.721 -245.149)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10961",
    "data-name": "Path 10961",
    d: "M678.712,298.241c.314-3.061-3-6.109-5.883-7.188a16.183,16.183,0,0,0-9.107,0,46.628,46.628,0,0,0-34.962,36.479,227.68,227.68,0,0,1,24.8-10.487l-1.43.414a28.94,28.94,0,0,0,19.582-14.326,15.505,15.505,0,0,1,2.622-4.014,3.876,3.876,0,0,1,4.4-.878",
    transform: "translate(-508.487 -261.999)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10962",
    "data-name": "Path 10962",
    d: "M668.6,297.981a37.521,37.521,0,0,1,27.447-6.159,32.829,32.829,0,0,1,22.819,16.07,29.153,29.153,0,0,1,.138,27.6c-4.441-9.22-9.2-18.817-17.449-24.863-1.944-1.4-4.127-2.7-5.219-4.842-1.254-2.509-.74-5.532-1.832-8.091-1.33-3.149-5.018-4.077-8.417-4.253s-13.322,2.973-17.487,4.491",
    transform: "translate(-498.35 -261.765)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10963",
    "data-name": "Path 10963",
    d: "M668.43,296.656c8.2-2.434,17.487,1.581,23.082,7.727s8.417,14.4,9.383,22.655.188,16.6-.652,24.863a103.681,103.681,0,0,1-14.138-31.361c-1.255-5.018-2.283-10.236-4.654-14.878a18.378,18.378,0,0,0-13.021-9.02",
    transform: "translate(-498.393 -260.591)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10964",
    "data-name": "Path 10964",
    d: "M669.055,304c6.561-3.036,10.261-9.885,11.1-17.073A21.677,21.677,0,0,0,672.2,267.76a23.22,23.22,0,0,0-6.122,24.261c1.392,3.952,3.914,7.9,2.973,11.98",
    transform: "translate(-499.294 -267.76)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10965",
    "data-name": "Path 10965",
    d: "M638.275,420.11a5.591,5.591,0,0,1-.414-.978c-.264-.652-.577-1.631-1.091-2.86-.953-2.509-2.509-6.021-4.478-10.3a267.2,267.2,0,0,0-18.516-32.089,257.157,257.157,0,0,0-22.505-29.442,70.545,70.545,0,0,0-8.053-7.8,20.237,20.237,0,0,0-2.509-1.731,7.039,7.039,0,0,1-.928-.527,9.143,9.143,0,0,1,.991.4,19.425,19.425,0,0,1,2.6,1.656,65.036,65.036,0,0,1,8.229,7.69A237.965,237.965,0,0,1,614.3,373.519a245.354,245.354,0,0,1,18.441,32.252c1.982,4.328,3.425,7.9,4.3,10.412.477,1.254.753,2.233.979,2.9a6.118,6.118,0,0,1,.251,1.029Z",
    transform: "translate(-520.95 -250.808)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10966",
    "data-name": "Path 10966",
    d: "M655.742,472.987H610.907l-6.987-51.9h60.164Z",
    transform: "translate(-514.808 -228.744)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10967",
    "data-name": "Path 10967",
    d: "M684.168,374.53c-4.529-9.722-16.17-16.07-26.858-15.2a8.267,8.267,0,0,1,4.453,5.921,50.276,50.276,0,0,1,.677,7.652c.966,12.281,8.869,22.756,16.446,32.453,5.331,6.812,10.7,13.661,17.073,19.519C695.195,407.409,694.091,388.906,684.168,374.53Z",
    transform: "translate(-501.222 -244.481)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10968",
    "data-name": "Path 10968",
    d: "M657.31,360.948c6.787-5.219,15.543-7.389,24.111-7.527s17.023,1.756,25.315,3.864c5.018,1.254,10.036,2.659,14.313,5.545s7.665,7.527,7.74,12.657c-7.037-7.74-18.378-9.233-28.426-12.156-6.8-1.97-13.372-4.8-20.31-6.272a36.015,36.015,0,0,0-22.743,3.763",
    transform: "translate(-501.222 -245.965)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10969",
    "data-name": "Path 10969",
    d: "M658.563,363.3c-2.973-3.124-1.33-10.425,1.254-13.862s6.711-5.382,10.776-6.824a74.816,74.816,0,0,1,16.521-3.851,17.011,17.011,0,0,1-5.231,9.2,50.045,50.045,0,0,1-8.706,6.272l-14.639,9.057",
    transform: "translate(-501.309 -249.694)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10970",
    "data-name": "Path 10970",
    d: "M640.344,355.452c-8.493,3.763-15.053,10.675-21.414,17.449a94.5,94.5,0,0,0,26.733-11.064c3.287-2.007,6.548-4.253,10.312-5.093s7.978.841,11.115,3.437C661.757,352.328,648.836,351.689,640.344,355.452Z",
    transform: "translate(-510.988 -246.013)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10971",
    "data-name": "Path 10971",
    d: "M632.813,409.478c4.754-10.914,2.747-24.148,8.781-34.4,4.629-7.853,13.159-12.545,21.652-15.831,1.969,5.908,1.029,12.545-1.468,18.227s-6.461,10.65-10.638,15.267c-5.783,6.385-12.068,12.294-18.34,18.2",
    transform: "translate(-507.459 -244.48)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1578",
    "data-name": "Rectangle 1578",
    width: 67.051,
    height: 11.679,
    transform: "translate(84.985 192.346)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10972",
    "data-name": "Path 10972",
    d: "M665.448,430.756c0,.188-14.514.326-32.4.326s-32.415-.138-32.415-.326,14.514-.326,32.415-.326S665.448,430.581,665.448,430.756Z",
    transform: "translate(-515.645 -226.368)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10973",
    "data-name": "Path 10973",
    d: "M682.85,301.145a74.363,74.363,0,0,0-7.79-11.729,24.926,24.926,0,0,0-11.453-7.891c-6.047-1.769-12.545-.364-18.566,1.43a148.629,148.629,0,0,0-20.611,7.853,40.845,40.845,0,0,0,27.4.489c4.616-1.568,9.095-1.367,13.937-.815,5.9.665,13.272,6.122,17.086,10.663",
    transform: "translate(-509.589 -264.465)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10974",
    "data-name": "Path 10974",
    d: "M546,356.257c-10.562,13.448-14.088,31.361-12.9,48.472a116.15,116.15,0,0,1,37.483-58.219c6.9-5.72,15.706-10.261,24.249-10.261C577.262,334.731,556.864,342.383,546,356.257Z",
    transform: "translate(-532.884 -250.381)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10975",
    "data-name": "Path 10975",
    d: "M569.768,330.644c-5.9.439-11.29,3.425-16.157,6.762-7.451,5.118-14.451,11.579-17.7,20.071a62.033,62.033,0,0,1,54.356-21.464C583.843,332.776,576.918,330.117,569.768,330.644Z",
    transform: "translate(-532.113 -251.776)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10976",
    "data-name": "Path 10976",
    d: "M577.247,315.4c-3.412,2.371-6.021,6.272-5.846,10.412a12.733,12.733,0,0,0,3.387,7.665,50.965,50.965,0,0,0,7.138,6.824c2.17-9.584,4.767-19.595,6.937-29.179A30.973,30.973,0,0,0,577.247,315.4Z",
    transform: "translate(-523.084 -256.727)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10977",
    "data-name": "Path 10977",
    d: "M594.651,315.222a28.627,28.627,0,0,0-10.964,11.93c-2.246,5.018-3.174,11.29-.351,15.982a410.063,410.063,0,0,1,26.143-34.924A85.3,85.3,0,0,0,594.651,315.222Z",
    transform: "translate(-520.492 -257.467)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10978",
    "data-name": "Path 10978",
    d: "M611.147,326.936A32.892,32.892,0,0,0,583.16,339.2a27.3,27.3,0,0,1,15.053-2.848,360.1,360.1,0,0,1,38.625,7.163,32.879,32.879,0,0,0-25.691-16.584Z",
    transform: "translate(-520.09 -252.723)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10979",
    "data-name": "Path 10979",
    d: "M589.05,336.05c-9.96.552-18.666,8.217-22.141,17.562s-2.283,19.946,1.468,29.179,9.91,17.286,16.421,24.838c3.262-11.29,6.548-22.58,7.991-34.146S593.127,347.014,589.05,336.05Z",
    transform: "translate(-524.751 -250.383)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7803",
    "data-name": "Group 7803",
    transform: "translate(0 50.743)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10980",
    "data-name": "Path 10980",
    d: "M546,356.257c-10.562,13.448-14.088,31.361-12.9,48.472a116.15,116.15,0,0,1,37.483-58.219c6.9-5.72,15.706-10.261,24.249-10.261C577.262,334.731,556.864,342.383,546,356.257Z",
    transform: "translate(-532.884 -301.124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10981",
    "data-name": "Path 10981",
    d: "M569.768,330.644c-5.9.439-11.29,3.425-16.157,6.762-7.451,5.118-14.451,11.579-17.7,20.071a62.033,62.033,0,0,1,54.356-21.464C583.843,332.776,576.918,330.117,569.768,330.644Z",
    transform: "translate(-532.113 -302.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10982",
    "data-name": "Path 10982",
    d: "M577.247,315.4c-3.412,2.371-6.021,6.272-5.846,10.412a12.733,12.733,0,0,0,3.387,7.665,50.965,50.965,0,0,0,7.138,6.824c2.17-9.584,4.767-19.595,6.937-29.179A30.973,30.973,0,0,0,577.247,315.4Z",
    transform: "translate(-523.084 -307.469)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10983",
    "data-name": "Path 10983",
    d: "M594.651,315.222a28.627,28.627,0,0,0-10.964,11.93c-2.246,5.018-3.174,11.29-.351,15.982a410.063,410.063,0,0,1,26.143-34.924A85.3,85.3,0,0,0,594.651,315.222Z",
    transform: "translate(-520.492 -308.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10984",
    "data-name": "Path 10984",
    d: "M611.147,326.936A32.892,32.892,0,0,0,583.16,339.2a27.3,27.3,0,0,1,15.053-2.848,360.1,360.1,0,0,1,38.625,7.163,32.879,32.879,0,0,0-25.691-16.584Z",
    transform: "translate(-520.09 -303.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10985",
    "data-name": "Path 10985",
    d: "M589.05,336.05c-9.96.552-18.666,8.217-22.141,17.562s-2.283,19.946,1.468,29.179,9.91,17.286,16.421,24.838c3.262-11.29,6.548-22.58,7.991-34.146S593.127,347.014,589.05,336.05Z",
    transform: "translate(-524.751 -301.126)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7804",
    "data-name": "Group 7804",
    transform: "translate(107.942 89.066)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10986",
    "data-name": "Path 10986",
    d: "M684.168,374.53c-4.529-9.722-16.17-16.07-26.858-15.2a8.267,8.267,0,0,1,4.453,5.921,50.276,50.276,0,0,1,.677,7.652c.966,12.281,8.869,22.756,16.446,32.453,5.331,6.812,10.7,13.661,17.073,19.519C695.195,407.409,694.091,388.906,684.168,374.53Z",
    transform: "translate(-609.164 -333.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10987",
    "data-name": "Path 10987",
    d: "M657.31,360.948c6.787-5.219,15.543-7.389,24.111-7.527s17.023,1.756,25.315,3.864c5.018,1.254,10.036,2.659,14.313,5.545s7.665,7.527,7.74,12.657c-7.037-7.74-18.378-9.233-28.426-12.156-6.8-1.97-13.372-4.8-20.31-6.272a36.015,36.015,0,0,0-22.743,3.763",
    transform: "translate(-609.164 -335.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10988",
    "data-name": "Path 10988",
    d: "M658.563,363.3c-2.973-3.124-1.33-10.425,1.254-13.862s6.711-5.382,10.776-6.824a74.816,74.816,0,0,1,16.521-3.851,17.011,17.011,0,0,1-5.231,9.2,50.045,50.045,0,0,1-8.706,6.272l-14.639,9.057",
    transform: "translate(-609.25 -338.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10989",
    "data-name": "Path 10989",
    d: "M640.344,355.452c-8.493,3.763-15.053,10.675-21.414,17.449a94.5,94.5,0,0,0,26.733-11.064c3.287-2.007,6.548-4.253,10.312-5.093s7.978.841,11.115,3.437C661.757,352.328,648.836,351.689,640.344,355.452Z",
    transform: "translate(-618.93 -335.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10990",
    "data-name": "Path 10990",
    d: "M632.813,409.478c4.754-10.914,2.747-24.148,8.781-34.4,4.629-7.853,13.159-12.545,21.652-15.831,1.969,5.908,1.029,12.545-1.468,18.227s-6.461,10.65-10.638,15.267c-5.783,6.385-12.068,12.294-18.34,18.2",
    transform: "translate(-615.401 -333.546)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-35",
    transform: "translate(248.123 261.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10991",
    "data-name": "Path 10991",
    d: "M331.926,218.45H211.272A6.272,6.272,0,0,0,205,224.722v54.97a6.272,6.272,0,0,0,6.272,6.272H261.89l10.751,13.8,8.969-13.8h50.329a6.272,6.272,0,0,0,6.272-6.272V224.735a6.272,6.272,0,0,0-6.285-6.285Z",
    transform: "translate(-204.634 -218.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10992",
    "data-name": "Path 10992",
    d: "M332,218.508h.6a5.959,5.959,0,0,1,1.719.389,6.2,6.2,0,0,1,2.371,1.606,6.273,6.273,0,0,1,1.643,3.588c.113,5.984.088,14.69.125,25.716V278.3a15.582,15.582,0,0,1-.125,2.735,6.335,6.335,0,0,1-1.142,2.572,6.51,6.51,0,0,1-4.955,2.672h-50.63l.251-.138-8.957,13.8-.238.364-.263-.339-10.763-13.8.251.125H210.581a6.611,6.611,0,0,1-5.7-5.106,11.74,11.74,0,0,1-.163-2.622V224.793a6.573,6.573,0,0,1,3.575-5.846,6.473,6.473,0,0,1,2.258-.69c.79-.075,1.518,0,2.271,0h59.85l43.392.1,11.792.063h0l-11.792.063-43.392.1H210.644a5.62,5.62,0,0,0-2.045.627,5.984,5.984,0,0,0-3.236,5.306v53.8a11.5,11.5,0,0,0,.151,2.509,5.984,5.984,0,0,0,2.823,3.826,5.77,5.77,0,0,0,2.308.765c.8.075,1.706,0,2.509,0h48.924l.088.125,10.751,13.8h-.5l8.969-13.8.088-.138h50.768a6.034,6.034,0,0,0,5.645-4.817,15.345,15.345,0,0,0,.125-2.647V249.455c0-11.014.088-19.758,0-25.7a6.272,6.272,0,0,0-3.864-5.118,7.529,7.529,0,0,0-2.145-.125Z",
    transform: "translate(-204.708 -218.223)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1579",
    "data-name": "Rectangle 1579",
    width: 15.229,
    height: 11.792,
    rx: 1.28,
    transform: "translate(21.315 12.302)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10993",
    "data-name": "Path 10993",
    d: "M221.906,228.335l5.8,6.184a2.346,2.346,0,0,0,1.254.866,1.831,1.831,0,0,0,1.694-.652c1.054-1.079,2.057-2.2,3.086-3.287s1.957-2.07,2.923-3.111a.163.163,0,0,0-.226-.226L230.9,234a4.854,4.854,0,0,1-.878.878c-.828.527-1.53,0-2.082-.59-1.054-1.1-2.095-2.22-3.136-3.337l-2.659-2.848c-.138-.138-.364.075-.226.226Z",
    transform: "translate(-200.34 -215.719)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10994",
    "data-name": "Path 10994",
    d: "M221.9,238.65l4.654-5.294.652-.74c.138-.151-.088-.376-.213-.226-1.556,1.769-3.111,3.525-4.654,5.294l-.665.74C221.552,238.575,221.766,238.8,221.9,238.65Z",
    transform: "translate(-200.4 -214.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10995",
    "data-name": "Path 10995",
    d: "M234.714,238.179l-4.353-5.018-.627-.728c-.138-.163-.351,0-.226.213l4.353,5.018c.213.251.427.489.627.74S234.852,238.329,234.714,238.179Z",
    transform: "translate(-198.408 -214.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10996",
    "data-name": "Path 10996",
    d: "M244,237.251v-3.9l-1.919,3.211H241.4l-1.907-3.136v3.826H238.08V230.74h1.254l2.409,4.09,2.4-4.052h1.254v6.511Z",
    transform: "translate(-196.217 -215.038)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10997",
    "data-name": "Path 10997",
    d: "M250.061,234.867H246.3a1.33,1.33,0,0,0,1.43,1,1.681,1.681,0,0,0,1.254-.477l.778.84a2.634,2.634,0,0,1-2.07.8,2.6,2.6,0,0,1-2.86-2.572,2.617,2.617,0,1,1,5.231.075Zm-3.763-.84h2.509a1.254,1.254,0,0,0-2.509,0Z",
    transform: "translate(-194.499 -214.749)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10998",
    "data-name": "Path 10998",
    d: "M249.36,236.5l.489-1.041a3.375,3.375,0,0,0,1.731.489c.677,0,.928-.188.928-.464,0-.815-3.023,0-3.023-1.982,0-.941.853-1.618,2.308-1.618a4.177,4.177,0,0,1,1.932.439l-.489,1.029a2.86,2.86,0,0,0-1.443-.364c-.652,0-.928.2-.928.464,0,.853,3.023,0,3.023,1.995,0,.928-.866,1.593-2.358,1.593a4.215,4.215,0,0,1-2.17-.539Z",
    transform: "translate(-193.346 -214.748)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10999",
    "data-name": "Path 10999",
    d: "M253.3,236.5l.477-1.041a3.45,3.45,0,0,0,1.744.489c.665,0,.916-.188.916-.464,0-.815-3.023,0-3.023-1.982,0-.941.853-1.618,2.321-1.618a4.089,4.089,0,0,1,1.919.439l-.477,1.029a2.9,2.9,0,0,0-1.443-.364c-.652,0-.928.2-.928.464,0,.853,3.023,0,3.023,1.995,0,.928-.866,1.593-2.371,1.593A4.2,4.2,0,0,1,253.3,236.5Z",
    transform: "translate(-192.344 -214.748)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11000",
    "data-name": "Path 11000",
    d: "M262.114,234.1v2.86h-1.367v-.627a1.618,1.618,0,0,1-1.518.7c-1.179,0-1.869-.652-1.869-1.518s.615-1.493,2.145-1.493h1.167c0-.627-.376-.991-1.154-.991a2.421,2.421,0,0,0-1.443.464l-.514-1.016a3.826,3.826,0,0,1,2.158-.6C261.224,231.88,262.114,232.6,262.114,234.1Zm-1.455,1.254v-.514h-.991c-.677,0-.9.251-.9.59s.314.6.828.6a1.066,1.066,0,0,0,1.079-.652Z",
    transform: "translate(-191.311 -214.749)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11001",
    "data-name": "Path 11001",
    d: "M267.467,231.956v4.165a2.509,2.509,0,0,1-2.81,2.722,4.165,4.165,0,0,1-2.509-.69l.577-1.041a3.036,3.036,0,0,0,1.769.564c1.029,0,1.468-.464,1.468-1.367V236.1a2.02,2.02,0,0,1-1.581.627,2.421,2.421,0,0,1,0-4.842,2.02,2.02,0,0,1,1.656.715v-.64Zm-1.43,2.346a1.317,1.317,0,1,0-1.254,1.254A1.254,1.254,0,0,0,266.037,234.3Z",
    transform: "translate(-190.14 -214.749)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11002",
    "data-name": "Path 11002",
    d: "M272.369,234.867h-3.763a1.33,1.33,0,0,0,1.43,1,1.669,1.669,0,0,0,1.255-.477l.778.84a2.634,2.634,0,0,1-2.07.8,2.6,2.6,0,0,1-2.848-2.572,2.635,2.635,0,1,1,5.269.013A2.692,2.692,0,0,0,272.369,234.867Zm-3.763-.84h2.509a1.254,1.254,0,0,0-2.509,0Z",
    transform: "translate(-188.82 -214.749)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11003",
    "data-name": "Path 11003",
    d: "M271.71,236.5l.489-1.041a3.412,3.412,0,0,0,1.744.489c.665,0,.916-.188.916-.464,0-.815-3.023,0-3.023-1.982,0-.941.853-1.618,2.321-1.618a4.127,4.127,0,0,1,1.919.439l-.477,1.029a2.923,2.923,0,0,0-1.443-.364c-.652,0-.941.2-.941.464,0,.853,3.023,0,3.023,1.995,0,.928-.853,1.593-2.358,1.593a4.253,4.253,0,0,1-2.17-.539Z",
    transform: "translate(-187.659 -214.748)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11004",
    "data-name": "Path 11004",
    d: "M277.891,234.1a3.563,3.563,0,1,1,3.563,3.362,3.374,3.374,0,0,1-3.563-3.362Zm5.595,0a2.045,2.045,0,1,0-2.032,2.082,1.995,1.995,0,0,0,2.032-2.082Z",
    transform: "translate(-186.088 -215.14)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11005",
    "data-name": "Path 11005",
    d: "M285.892,231.974H283.81V230.72h5.67v1.254H287.4v5.281h-1.505Z",
    transform: "translate(-184.58 -215.043)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11006",
    "data-name": "Path 11006",
    d: "M294.62,233.1c0,1.455-1.091,2.358-2.835,2.358H290.53v1.794H289V230.74h2.81C293.529,230.74,294.62,231.643,294.62,233.1Zm-1.53,0c0-.715-.464-1.129-1.38-1.129h-1.254v2.258h1.254C292.625,234.227,293.09,233.813,293.09,233.1Z",
    transform: "translate(-183.26 -215.038)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11007",
    "data-name": "Path 11007",
    d: "M221,253.064c0-6.147,3.412-9.634,7.978-9.634s7.991,3.487,7.991,9.634-3.387,9.634-7.991,9.634S221,259.2,221,253.064Zm11.629,0c0-4.228-1.493-5.984-3.65-5.984s-3.613,1.756-3.613,5.984,1.493,5.984,3.613,5.984,3.663-1.756,3.663-5.984Z",
    transform: "translate(-200.563 -211.809)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11008",
    "data-name": "Path 11008",
    d: "M251.023,256.965c0,3.512-3.136,5.72-7.865,5.72s-7.828-2.208-7.828-5.72a4.742,4.742,0,0,1,2.823-4.391,4.315,4.315,0,0,1-2.158-3.763c0-3.274,2.923-5.331,7.163-5.331s7.2,2.057,7.2,5.331a4.315,4.315,0,0,1-2.183,3.763,4.7,4.7,0,0,1,2.848,4.391Zm-4.353-.138c0-1.643-1.367-2.659-3.512-2.659s-3.462,1.016-3.462,2.659,1.33,2.7,3.462,2.7S246.67,258.483,246.67,256.827Zm-6.385-7.9c0,1.418,1.116,2.3,2.873,2.3s2.923-.878,2.923-2.3-1.129-2.283-2.923-2.283-2.873.828-2.873,2.283Z",
    transform: "translate(-196.916 -211.797)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11009",
    "data-name": "Path 11009",
    d: "M265.036,256.965c0,3.512-3.149,5.72-7.878,5.72s-7.828-2.208-7.828-5.72a4.742,4.742,0,0,1,2.823-4.391,4.315,4.315,0,0,1-2.158-3.763c0-3.274,2.935-5.331,7.163-5.331s7.213,2.057,7.213,5.331a4.34,4.34,0,0,1-2.183,3.763,4.717,4.717,0,0,1,2.848,4.391Zm-4.366-.138c0-1.643-1.355-2.659-3.512-2.659s-3.462,1.016-3.462,2.659,1.33,2.7,3.462,2.7S260.67,258.483,260.67,256.827Zm-6.385-7.9c0,1.418,1.116,2.3,2.873,2.3s2.923-.878,2.923-2.3-1.129-2.283-2.923-2.283-2.873.828-2.873,2.283Z",
    transform: "translate(-193.354 -211.797)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11010",
    "data-name": "Path 11010",
    d: "M270.789,243.69v18.629h-4.315V247.152H262.71V243.69Z",
    transform: "translate(-189.949 -211.743)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11011",
    "data-name": "Path 11011",
    d: "M285.858,258.875v3.512H271.783v-2.8l7.175-6.787c1.656-1.568,1.944-2.509,1.944-3.437,0-1.455-1-2.308-2.973-2.308a4.566,4.566,0,0,0-3.864,1.857l-3.136-2.02a8.656,8.656,0,0,1,7.4-3.462c4.14,0,6.912,2.133,6.912,5.507,0,1.819-.5,3.462-3.111,5.883l-4.29,4.052Z",
    transform: "translate(-187.858 -211.812)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11012",
    "data-name": "Path 11012",
    d: "M298.228,256.623c0,3.136-2.421,6.009-7.715,6.009a12.833,12.833,0,0,1-7.113-1.995l1.681-3.3a9.007,9.007,0,0,0,5.319,1.681c2.158,0,3.487-.878,3.487-2.4s-1.041-2.3-3.487-2.3H288.43V251.48l3.839-4.328h-7.928V243.69h13.034v2.8l-4.2,4.779C296.522,251.806,298.228,253.876,298.228,256.623Z",
    transform: "translate(-184.685 -211.743)",
    fill: "#263238"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpRightImage);
export default __webpack_public_path__ + "static/media/otp-right-image.dedc926b1d58c3ae30905c795753b38e.svg";
export { ForwardRef as ReactComponent };